import { useCallback, useEffect, useState, useRef } from 'react';
import {
  CircularProgress as MuiCircularProgress,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  Zoom,
  DialogContentText,
  DialogTitle,
  IconButton,
  Button,
} from '@material-ui/core';
import Spinner from 'Components/Spinner';
import CloseIcon from '@material-ui/icons/Close';
import {
  axios,
  baseUrl,
  dataFetcher,
  endpoints,
  firebaseCredentials,
  cloudBaseUrl,
} from 'Api';
import { getAllActivePlans, addVideo } from 'Api/apiFunctions';
import { logAppEvent } from 'Api/errorLogger';
import { ALLOWED_UPLOADS_COUNT, PLANS } from 'Commons';
import { Snackbar } from 'Components';
import { ToastContainer, toast } from 'react-toastify';
import noPhotoAvailable from 'Assets/no-image-available.png';
import ForNoImage from 'Assets/Placeholder.png';
import 'react-toastify/dist/ReactToastify.css';
import Referral from 'Pages/private/Referral';
import ListingModal from 'Components/ListingModal';
import { AppContext, AuthContext } from 'Context';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { saveUploadInfo, saveUploadDetails, saveTitle, saveDummy, removeDummy, removeTitle } from 'store/store';
import { initializeApp } from 'firebase/app';
import { ref, getDatabase, off, onValue, update } from 'firebase/database';
import AWS from 'aws-sdk';
import { awsConfig, generateS3Url, getBucketName, getBucketNamePath } from 'Api/awsConfig';
import 'Utils/debugToken'; // Token debugging utility (available as window.debugToken())
import 'Api/signinIntegration'; // Signin helper (available as window.saveTokensFromResponse())
import {
  Access,
  AccountSettings,
  AlbumDetails,
  AlbumPlayer,
  BillingSettings,
  CloudSettings,
  ConnectedAccountSettings,
  ContentLayout,
  ContentLayoutDashboard,
  ContentLayoutDetails,
  Dashboard,
  Storage,
  EmailVerification,
  EmailVerificationLink,
  ForgotPassword,
  SetPassword,
  GettingStarted,
  Groups,
  LandingPage,
  ManageDevice,
  ManagePaymentMethods,
  MobileVerification,
  NotificationSettings,
  Privacy,
  PrivacySettings,
  Profile,
  PublicPlans,
  SearchPage,
  SignUp,
  SubscriberAgreementPage,
  SubscriberAgreementSettings,
  Successors,
  TermsAndConditionSettings,
  TermsAndConditions,
  TermsAndServices,
  VerifyCode,
  VideoDetails,
  VideoPlayer,
  Viewers,
  Watchlist,
  YourVideos,
} from 'Pages';
import { InnerPage } from 'Pages/private/innerpage';
import { NewMobileVerification } from 'Pages/public/authentication/newMobile-verification';
import { NewSignUP } from 'Pages/public/authentication/newSign-Up';
import { NewSignIn } from 'Pages/public/authentication/newSign-in';
import { Welcome } from 'Pages/public/authentication/Trail/Welcome';
import { NewVerifyCode } from 'Pages/public/authentication/newVerification-code';
import { GiftFlowIntro } from 'Pages/public/gift-flow';
import { ReceivingGift } from 'Pages/public/receiving-gift';
import { GiftPayment } from 'Pages/public/gift-payment';
import { GiftContent } from 'Pages/public/gift-content';
import { Pathname } from 'Routes';
import 'Styles/site-global.css';
import './Pages/public/landing-external2/App.css';
import detectBrowserLanguage from 'detect-browser-language';
import useMyAxios from 'hooks/useMyAxios';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import useSWR from 'swr';
import MangerPaymentForUser from 'Pages/userManagement/MangerPaymentForUser';
import { PlanForAffliate } from 'Pages/public/landing/plans/PlanForAffliate';
import { UserMangementSettings } from 'Pages/userManagement/UserMangementSettings';
import { CloudUpload } from 'Pages/cloudUpload';
import CreateUser from 'CreateNewUser/CreateUser';
import QuickUserUploadPage from 'Pages/userManagement/QuickUserUploadPage';
import ListingModalCopy from 'Components/ListingModalCopy';
import AddPlaylistModal from 'Components/AddPlaylistModal';
import AddSubCategoryModal from 'Components/AddSubCategoryModal';
import DropMe from 'Components/DropMe/DropMe';
import SuccessPopUp from 'Components/VideoPopup/SuccessPopUp';
// import QRCodeComponent from 'Utils/QRCodeComponent';
import { PhotoStorage } from 'Pages/private/storage/cloud/PhotoStorage';
import { CategoryCloud } from 'Pages/private/storage/cloud/CategoryCloud';
import { AlbumCloudStorage } from 'Pages/private/storage/cloud/AlbumCloudStorage';
import { GooglePhotosCloud } from 'Pages/private/storage/cloud/GooglePhotosCloud';
import { InviteEachUser } from 'Pages/public/authentication/Trail/InviteEachUser';
import { DeviceList } from 'Pages/public/authentication/Trail/DeviceList';
import { NewVerificationEmail } from 'Pages/public/authentication/newVerification-code/NewVerificationEmail';
import CardExp from 'Utils/CardExp';
import RotatingLoader from 'Components/RotatingLoader';
import { PlanToSwitch } from 'Pages/public/landing/plans/PlanToSwitch';
import { Avatar } from 'Pages/public/authentication/newSign-in/Avatar';
import VerifyUsingLink from 'Pages/public/authentication/newSign-in/VerifyUsingLink';
import AutoLogin from 'Pages/public/authentication/AutoLogin';
import ShortLink from 'Pages/public/ShortLink';
import { navigateTo } from './navigationHelper';
import { UploadModal } from './Components/upload-modal/index';
import UploadPanel from './Components/UploadPanel/UploadPanel';
import { UPLOAD_CONFIG } from './Config/uploadConfig';
import SubscriberAgreementDarkMode from './Pages/public/SubscriberAgreementDarkMode';
import DownArrow from './Assets/arrowdown.png';
import UpArrow from './Assets/arrowup.png';
import styles from './app.module.css';

const CircularProgress = withStyles({
  circle: {
    color: '#fff !important',
  },
})(MuiCircularProgress);

// Redirect to external landing page for logged out users
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    // Check if user has token - if so, don't redirect (they just logged in)
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = to;
    }
  }, [to]);
  return null;
};

const defaultAppSnackbar = {
  isVisible: false,
  type: undefined,
  message: '',
  duration: 1500,
};
const appSnackbarAutoHideDuration = 1500;
const getToken = () => localStorage.getItem('token');
const setToken = (token) => {
  localStorage.setItem('token', token);
};
const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('inviteUser');
  localStorage.removeItem('dismissedPaymentDialog');
};
const setEmailVerified = (isVerified) => {
  localStorage.setItem('isVerified', isVerified);
};
const getEmailVerified = () => localStorage.getItem('isVerified');
const removeEmailVerified = () => {
  localStorage.removeItem('isVerified');
};
const RouteSwitch = ({
  isNewUser,
  userIsSignedIn,
  isInActiveUser,
  isEmailAllowed,
}) => {
  const currentLocation = useLocation();
  const routeNavigate = useNavigate();
  const [routeSearchParams] = useSearchParams();

  // Persist ?fromGift=true across all navigations once set from /profile?fromGift=true
  useEffect(() => {
    const hasFromGiftInUrl = routeSearchParams.get('fromGift') === 'true';
    const hasFromGiftInSession = sessionStorage.getItem('fromGift') === 'true';

    if (hasFromGiftInUrl && !hasFromGiftInSession) {
      sessionStorage.setItem('fromGift', 'true');
    }

    if (!hasFromGiftInUrl && hasFromGiftInSession) {
      const newParams = new URLSearchParams(currentLocation.search);
      newParams.set('fromGift', 'true');
      routeNavigate(`${currentLocation.pathname}?${newParams.toString()}`, { replace: true });
    }
  }, [currentLocation.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentLocation.pathname]);
  useEffect(() => {
    if (window.gtag) {
      // Set user property (you’ll see this in DebugView if enabled)
      window.gtag('set', {
        user_properties: {
          dev_user: 'dev testing in prod',
        },
      });
      console.log('GA page view for:', currentLocation.pathname);
      // Send page view with route info
      window.gtag('config', 'G-8QBGJ3N2K3', {
        page_path: currentLocation.pathname,
      });
    }
  }, [currentLocation]);
  return (
    <Routes>
      {userIsSignedIn ? (
        isInActiveUser ? (
          <>
            <Route path={Pathname.access} element={<Access />} />
            <Route path={Pathname.dashboard} element={<Dashboard />} />
            <Route
              path={Pathname.authentication.ecosystem}
              element={<DeviceList />}
            />
            {/* <Route path={Pathname.storage.basePath}>
                <Route index element={<Storage />} />
              </Route> */}
            <Route
              path={Pathname.settings.basePath}
              element={<BillingSettings />}
            >
              <Route index element={<BillingSettings />} />
              {/* <Route path="manage-payment-methods" element={<ManagePaymentMethods />} /> */}
              <Route path="privacy" element={<PrivacySettings />} />
              <Route path="billings" element={<BillingSettings />} />
              <Route
                path="termsAndConditions"
                element={<TermsAndConditionSettings />}
              />
              <Route
                path="subscriberAgreement"
                element={<SubscriberAgreementSettings />}
              />
            </Route>
            <Route path={Pathname.settings.basePath}>
              <Route index element={<AccountSettings />} />
              <Route
                path="manage-payment-methods"
                element={<ManagePaymentMethods />}
              />
              <Route
                path="billings-and-payments"
                element={<BillingSettings />}
              />
            </Route>
            <Route path={Pathname.profile.basePath} element={<Profile />}>
              <Route index element={<Profile />} />
              <Route path=":profileID" element={<Profile />} />
            </Route>
            <Route path={Pathname.watchlist.basePath} element={<Watchlist />}>
              <Route index element={<Watchlist />} />
              <Route path=":profileID" element={<Watchlist />} />
            </Route>
            <Route path={Pathname.search.basePath} element={<SearchPage />}>
              <Route index element={<SearchPage />} />
              <Route path=":profileID" element={<SearchPage />} />
            </Route>
            <Route path={Pathname.video} element={<VideoDetails />} />
            <Route path={Pathname.album} element={<AlbumDetails />} />
            <Route path={Pathname.player} element={<VideoPlayer />} />
            <Route path={Pathname.playerFormat} element={<VideoPlayer />} />
            <Route path={Pathname.albumPlayer} element={<AlbumPlayer />} />
            <Route
              path={Pathname.authentication.setPassword}
              element={<SetPassword />}
            />
            <Route path={Pathname.innerpage} element={<InnerPage />} />
            <Route path={Pathname.home} element={<Access />} />
            <Route
              path={Pathname.plans}
              element={<PublicPlans userIsSignedIn={userIsSignedIn} />}
            />
            <Route
              path={Pathname.purchasePlans}
              element={<PublicPlans userIsSignedIn={userIsSignedIn} />}
            />
            <Route path="*" element={<Navigate to={Pathname.dashboard} />} />
          </>
        ) : (
          <>
            <Route path={Pathname.home} element={<Access />} />
            <Route
              path={Pathname.authentication.toTrail}
              element={<Welcome />}
            />
            <Route
              path={Pathname.authentication.avatar}
              element={<Avatar />}
            />
            <Route
              path={Pathname.authentication.invite}
              element={<InviteEachUser />}
            />
            <Route
              path={Pathname.authentication.ecosystem}
              element={<DeviceList />}
            />
            <Route
              path={Pathname.gettingStarted}
              element={<GettingStarted />}
            />
            <Route path={Pathname.access} element={<Access />} />
            <Route path={Pathname.innerpage} element={<InnerPage />} />
            <Route path={Pathname.dashboard} element={<Dashboard />} />
            <Route path={Pathname.storage.basePath}>
              <Route path="/storage/videos" element={<Storage />} />
              <Route
                path="/storage/videos/:category"
                element={<CategoryCloud />}
              />
              <Route
                path="/storage/photos/:albumid"
                element={<AlbumCloudStorage />}
              />
              <Route path="/storage/photos" element={<PhotoStorage />} />
              <Route
                path="/storage/google-photos"
                element={<GooglePhotosCloud />}
              />
            </Route>
            <Route path={Pathname.yourVideos} element={<YourVideos />} />
            <Route path={Pathname.contentLayout} element={<ContentLayout />} />
            <Route
              path={Pathname.contentLayoutDashboard}
              element={<ContentLayoutDashboard />}
            />
            <Route
              path={Pathname.contentYourVideosDashboard}
              element={<ContentLayoutDashboard />}
            />
            <Route
              path={Pathname.contentLayoutType}
              element={<ContentLayoutDetails />}
            />
            <Route path={Pathname.tvLogin} element={<ManageDevice />} />
            <Route
              path={Pathname.authentication.mobileVerification}
              element={<MobileVerification />}
            />
            <Route
              path={Pathname.authentication.newmobileVerification}
              element={<NewMobileVerification />}
            />
            <Route
              path={Pathname.authentication.verifyCode}
              element={<VerifyCode />}
            />
            {/* <Route path={Pathname.authentication.newverifyCode} element={<NewVerifyCode />} /> */}
            <Route path={Pathname.viewers.basePath}>
              <Route index element={<Viewers />} />
              <Route path="viewerlists" element={<Viewers />} />
              <Route path="groups" element={<Groups />} />
              <Route path="successors" element={<Successors />} />
            </Route>
            <Route path={Pathname.settings.basePath}>
              <Route index element={<AccountSettings />} />
              <Route path="accounts" element={<AccountSettings />} />
              <Route path="notifications" element={<NotificationSettings />} />
              <Route
                path="manage-payment-methods"
                element={<ManagePaymentMethods />}
              />
              <Route
                path="manageUsers"
                element={<ConnectedAccountSettings />}
              />
              <Route
                path="cloud"
                element={<CloudSettings />}
              />
              <Route
                path="billings-and-payments"
                element={<BillingSettings />}
              />
              <Route
                path="terms-of-use"
                element={<TermsAndConditionSettings />}
              />
              <Route
                path="subscriber-agreement"
                element={<SubscriberAgreementSettings />}
              />
              <Route path="privacy" element={<PrivacySettings />} />
              <Route path="manage-users" element={<UserMangementSettings />} />
            </Route>
            <Route path={Pathname.profile.basePath} element={<Profile />}>
              <Route index element={<Profile />} />
              <Route path=":profileID" element={<Profile />} />
            </Route>
            <Route path={Pathname.watchlist.basePath} element={<Watchlist />}>
              <Route index element={<Watchlist />} />
              <Route path=":profileID" element={<Watchlist />} />
            </Route>

            <Route path={Pathname.search.basePath} element={<SearchPage />}>
              <Route index element={<SearchPage />} />
              <Route path=":profileID" element={<SearchPage />} />
            </Route>
            <Route>
              <Route path="create-user" element={<CreateUser />} />
            </Route>
            <Route>
              <Route path="quick-user-upload" element={<QuickUserUploadPage />} />
            </Route>
            <Route>
              <Route path="cloud-upload" element={<CloudUpload />} />
            </Route>
            <Route>
              <Route path="pay-by-manger" element={<MangerPaymentForUser />} />
            </Route>
            <Route>
              <Route path="affiliate" element={<PlanForAffliate />} />
            </Route>
            <Route>
              <Route path="switchplan" element={<PlanToSwitch />} />
            </Route>
            <Route>
              <Route path="/referral/:code" element={<Referral />} />
            </Route>
            <Route path={Pathname.video} element={<VideoDetails />} />
            <Route path={Pathname.album} element={<AlbumDetails />} />
            <Route path={Pathname.player} element={<VideoPlayer />} />
            <Route path={Pathname.playerFormat} element={<VideoPlayer />} />
            <Route path={Pathname.albumPlayer} element={<AlbumPlayer />} />
            <Route
              path={Pathname.authentication.setPassword}
              element={<SetPassword />}
            />
            <Route
              path={Pathname.plans}
              element={<PublicPlans userIsSignedIn={userIsSignedIn} />}
            />
            <Route
              path={Pathname.purchasePlans}
              element={<PublicPlans userIsSignedIn={userIsSignedIn} />}
            />
            <Route
              path={Pathname.projectorTermsAndServices}
              element={<TermsAndServices />}
            />
            <Route path={Pathname.shortLink} element={<ShortLink />} />
            <Route
              path={Pathname.giftFlow.intro}
              element={<GiftFlowIntro />}
            />
            <Route
              path={Pathname.giftFlow.receiving}
              element={<ReceivingGift />}
            />
            <Route
              path={Pathname.giftFlow.payment}
              element={<GiftPayment />}
            />
            <Route
              path={Pathname.giftFlow.content}
              element={<GiftContent />}
            />
            <Route path="cloud-upload" element={<CloudUpload />} />
            <Route path="*" element={<Navigate to={Pathname.access} />} />
          </>
        )
      ) : (
        <>
          <Route path={Pathname.home} element={<ExternalRedirect to="https://www.projectorstream.com/" />} />
          {/* ORIGINAL - Commented out for WordPress redirect:
          <Route
            path={Pathname.plans}
            element={<PublicPlans userIsSignedIn={userIsSignedIn} />}
          />
          */}
          <Route
            path={Pathname.plans}
            element={<ExternalRedirect to="https://www.projectorstream.com/" />}
          />
          <Route>
            <Route path="/referral/:code" element={<Referral />} />
          </Route>
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms-of-use" element={<TermsAndConditions />} />
          <Route
            path="/subscriberAgreement"
            element={<SubscriberAgreementDarkMode />}
          />
          <Route path={Pathname.settings.basePath}>
            <Route index element={<Privacy />} />
            <Route
              path={`${Pathname.settings.basePath}/privacy`}
              element={<Privacy />}
            />
            <Route
              path={`${Pathname.settings.basePath}/terms-of-use`}
              element={<TermsAndConditions />}
            />
            <Route
              path={`${Pathname.settings.basePath}/subscriber-agreement`}
              element={<SubscriberAgreementDarkMode />}
            />
          </Route>
          {/* <Route path={Pathname.authentication.signUp} element={<SignUp />} /> */}
          <Route
            path={Pathname.authentication.signUp_refferedBy}
            element={<SignUp />}
          />
          <Route path={Pathname.authentication.signIn} element={<NewSignIn />} />
          <Route
            path={Pathname.authentication.newSignUp}
            element={<NewSignIn />}
          />
          <Route
            path={Pathname.authentication.newsignIn}
            element={<NewSignIn />}
          />
          <Route path="/sign-in" element={<Navigate to="/newSign-in" replace />} />
          <Route
            path={Pathname.authentication.forgotPassword}
            element={<ForgotPassword />}
          />
          <Route
            path={Pathname.authentication.setPassword}
            element={<SetPassword />}
          />
          <Route
            path={Pathname.authentication.verifyEmail}
            element={<EmailVerification />}
          />
          <Route
            path={Pathname.authentication.verifyEmailLink}
            element={<EmailVerificationLink />}
          />
          <Route
            path={Pathname.authentication.verifyEmailFallback}
            element={<VerifyUsingLink />}
          />
          <Route
            path={Pathname.authentication.autoLogin}
            element={<AutoLogin />}
          />
          <Route
            path={Pathname.authentication.mobileVerification}
            element={<MobileVerification />}
          />
          <Route
            path={Pathname.authentication.newmobileVerification}
            element={<NewMobileVerification />}
          />
          <Route
            path={Pathname.authentication.verifyUsingLink}
            element={<VerifyUsingLink />}
          />
          <Route
            path={Pathname.authentication.newverifyCode}
            element={<NewVerifyCode />}
          />
          <Route
            path={Pathname.authentication.newverifyCodeEmail}
            element={<NewVerificationEmail />}
          />
          <Route
            path={Pathname.giftFlow.intro}
            element={<GiftFlowIntro />}
          />
          <Route
            path={Pathname.giftFlow.receiving}
            element={<ReceivingGift />}
          />
          <Route path="cloud-upload" element={<CloudUpload />} />
          <Route path={Pathname.shortLink} element={<ShortLink />} />
          <Route
            path="*"
            element={<ExternalRedirect to="https://www.projectorstream.com/" />}
          />
        </>
      )}
    </Routes>
  );
};

export const App = () => {
  const firebaseConfig = {
    apiKey: firebaseCredentials?.apiKey,
    authDomain: firebaseCredentials?.authDomain,
    databaseURL: firebaseCredentials?.databaseURL,
    projectId: firebaseCredentials?.projectId,
    storageBucket: firebaseCredentials?.storageBucket,
    messagingSenderId: firebaseCredentials?.messagingSenderId,
    appId: firebaseCredentials?.appId,
    measurementId: firebaseCredentials?.measurementId,
  };
  const app = initializeApp(firebaseConfig);
  const database = getDatabase(app);
  const dispatch = useDispatch();
  const [firebaseDatabase, setFirebaseDatabase] = useState(database);
  const databaseRefVer = ref(database, 'version');
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const [data, setData] = useState([]);
  useEffect(() => {
    const dataCallback = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        setData(dataObj);
      }
    };
    onValue(databaseRef, dataCallback);
    return () => {
      off(databaseRef, 'value', dataCallback);
    };
  }, []);

  useEffect(() => {
    const dataCallback = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        if (!localStorage.getItem('version')) {
          localStorage.setItem('version', dataObj);
        } else if (localStorage.getItem('version') !== dataObj.toString()) {
          // Clear cookies
          const cookies = document.cookie.split('; ');
          cookies.forEach((cookie) => {
            const [name] = cookie.split('=');
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
          });
          // Clear local storage
          localStorage.clear();
          // Clear session storage
          sessionStorage.clear();
          // Clear cache (for some browsers)
          if (window.caches) {
            window.caches.keys().then((cacheNames) => {
              cacheNames.forEach((cacheName) => {
                window.caches.delete(cacheName);
              });
            });
          }
          localStorage.setItem('version', dataObj);
          window.location.reload(true);
        }
      }
    };
    onValue(databaseRefVer, dataCallback);
    return () => {
      off(databaseRefVer, 'value', dataCallback);
    };
  }, []);
  const databaseRefMinor = ref(database, 'versionMinor');
  useEffect(() => {
    const dataCallbackMinor = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        if (!localStorage.getItem('versionMinor')) {
          localStorage.setItem('versionMinor', dataObj);
        } else if (
          localStorage.getItem('versionMinor') !== dataObj.toString()
        ) {
          localStorage.setItem('versionMinor', dataObj);
          window.location.reload(true);
        }
      }
    };
    onValue(databaseRefMinor, dataCallbackMinor);
    return () => {
      off(databaseRefMinor, 'value', dataCallbackMinor);
    };
  }, []);
  const [userIsSignedIn, setUserSignInStatus] = useState(false);
  const [removeProjectorTextChange, setRemoveProjectorTextChange] = useState(false);
  const [isS3UploadComplete, setS3UploadComplete] = useState({});
  let totalElapsedTime = 0;
  let totalElapsedSize = 0;
  let totalRemainingSize = 0;
  const [eta, setEta] = useState();
  const uploadDetails = useSelector((state) => state.uploadDetails);
  useEffect(() => {
    const values = Object.values(uploadDetails);
    totalElapsedTime = values.reduce((acc, item) => acc + item.elapsed_time, 0);
    totalElapsedSize = values.reduce((acc, item) => acc + item.elapsed_size, 0);
    totalRemainingSize = values.reduce(
      (acc, item) => acc + item.remaining_size,
      0
    );
    setEta(
      (
        (totalRemainingSize / (totalElapsedSize / totalElapsedTime) + 1)
        / 60
      )?.toFixed(0)
    );
  }, [uploadDetails, eta]);
  const totalOnGoingUploadSize = Object.values(uploadDetails).reduce(
    (acc, item) => acc + item.elapsed_size + item.remaining_size,
    0
  );
  // console.log('totalOnGoingUploadSize', totalOnGoingUploadSize);
  const [plansPage, setPlansPage] = useState(false);
  const [autoSigningIn, setAutoSignIn] = useState(true);
  const [fetchDraftID, setfetchDraftID] = useState();
  const addVideoUpdater = useSelector((state) => state.addVideo);
  const [draftCategoryState, setDraftCategoryState] = useState({});
  // console.log('draftCategoryState', draftCategoryState);
  const [options, setOptions] = useState([]);
  const [userDetails, setUserDetails] = useState({
    firstname: '',
    lastname: '',
    dpURL: '',
    email: '',
    mobile: '',
    isNewUser: undefined,
    emailNS: undefined,
    subscriptionNS: undefined,
    totalVideoUploaded: undefined,
    totalContentUploaded: undefined,
    totalPhotoUploaded: undefined,
    mfa: undefined,
    trial_used: undefined,
    isLoginUsingSocial: undefined,
  });
  const [formData, setFormData] = useState(new FormData());
  const [videoGroup, setVideoGroup] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [userConnections, setUserConnections] = useState([]);
  const [loadingForAccess, setloadingForAccess] = useState(false);
  const [preferredEmail, setPreferredEmail] = useState('');
  const [isCompleted, setisCompleted] = useState('nothing');
  const [preferredUserDetails, setPreferredUserDetails] = useState({
    firstName: '',
    lastName: '',
  });
  const [uploadContainer, setUploadContainer] = useState([]);
  const [uploadContainer2, setUploadContainer2] = useState([]);
  const [isInActiveUser, setInActiveUser] = useState(false);
  const [currentSelectedPlan, setCurrentSelectedPlan] = useState({
    type: undefined,
    selected: { isTrial: undefined, selectedPlan: undefined },
  });
  const [appSnackbar, setAppSnackbar] = useState(defaultAppSnackbar);
  const [isViewerListUpdated, setViewerListUpdate] = useState(false);
  const [allPlans, setAllPlans] = useState();
  const [draftContent, setDraftContent] = useState([]);
  const [videoUploadedParts, setVideoUploadedParts] = useState([]);
  const {
    response: plansRes,
    error: plansErr,
    loading: plansLoading,
    refetch: refetchPlans,
  } = useMyAxios(getAllActivePlans, null, 'ALL_ACTIVE_PLANS');

  function base64ToBinary(base64String) {
    const [header, base64Data] = base64String.split(',');
    // Decode base64 into binary
    const binaryString = atob(base64Data);
    const len = binaryString.length;
    const binaryData = new Uint8Array(len);
    // eslint-disable-next-line
    for (let i = 0; i < len; i++) {
      binaryData[i] = binaryString.charCodeAt(i);
    }
    const mimeType = header.match(/:(.*?);/)[1];
    return new Blob([binaryData], { type: mimeType });
  }
  const updateUploadedData = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };
  const updateUploadDetails = (draft_id, data) => {
    dispatch(saveUploadDetails({ [draft_id]: data }));
  };
  const [uploaderLoader, setUploaderLoader] = useState(false);
  const [holdWhileDelete, setholdWhileDelete] = useState(false);
  const { mutate: autoSignIn } = useSWR([endpoints.getMyProfile], {
    onSuccess: ({ success, data }) => {
      if (success) {
        setUserDetails({
          ...userDetails,
          firstname: data?.firstname,
          lastname: data?.lastname,
          dpURL: data?.image,
          email: data?.email,
          mobile: data?.mobile,
          isNewUser: data?.isNewUser,
          emailNS: data?.email_notification === '1',
          subscriptionNS: data?.sub_notification === '1',
          totalVideoUploaded: data?.totalVideoUploaded,
          totalContentUploaded: data?.totalContentUploaded,
          totalPhotoUploaded: data?.totalPhotoUploaded,
          myId: data?.id,
          mfa: data?.mfa,
          isSubscription: data?.subscription,
          trial_used: data?.trials_used,
          isLoginUsingSocial: data?.apple_connected === '1' || data?.google_connected === '1',
          appleAccountConnected: data?.apple_connected,
          googleAccountConnected: data?.google_connected,
        });
        localStorage.setItem('id', data?.id);
        setAutoSignIn(false);
        setUserSignInStatus(true);
        setUploaderLoader(false);
      } else {
        // removeToken();
        setUploaderLoader(false);
        setAutoSignIn(false);
        // removeEmailVerified();
      }
    },
    onError: () => {
      removeToken();
      setAutoSignIn(false);
      setUploaderLoader(false);
      removeEmailVerified();
      // Don't reload if we're on autoLogin page to prevent infinite loops
      if (!window.location.pathname.includes('autoLogin')) {
        window.location.reload();
      }
    },
  });
  const warningTitle = userDetails?.appleAccountConnected === '1'
    ? 'Apple Account Connected'
    : userDetails?.googleAccountConnected === '1'
      ? 'Google Account Connected'
      : 'Social Account Connected';

  const warningMessage = userDetails?.appleAccountConnected === '1'
    ? 'This account is connected through Apple login. Updating the email address will unlink it from your Apple account.'
    : userDetails?.googleAccountConnected === '1'
      ? 'This account is connected through Google login. Updating the email address will unlink it from your Google account.'
      : 'This account is connected through a social login. Updating the email address will unlink it from the associated social account.';
  const processedDraftIdsRef = useRef(new Set());
  const [getAccessChecker, setGetAccessChecker] = useState();
  const getAccessCheckerRef = useRef(getAccessChecker);
  useEffect(() => { getAccessCheckerRef.current = getAccessChecker; }, [getAccessChecker]);
  const navigateToInviteFirstTime = (contentCount) => {
    const alreadyInvited = localStorage.getItem('inviteUser') === 'true';
    const totalUploaded = contentCount ?? userDetails?.totalContentUploaded;
    // console.log('navigateToInviteFirstTime - contentCount:', contentCount);
    // console.log('navigateToInviteFirstTime - userDetails?.totalContentUploaded:', userDetails?.totalContentUploaded);
    // console.log('navigateToInviteFirstTime - totalUploaded:', totalUploaded);
    // console.log('navigateToInviteFirstTime - alreadyInvited:', alreadyInvited);
    // console.log('navigateToInviteFirstTime - condition result:', (totalUploaded === 0 || totalUploaded === 1) && !alreadyInvited);
    if (
      (totalUploaded === 0 || totalUploaded === 1)
      && !alreadyInvited
      && getAccessCheckerRef.current?.success !== true
    ) {
      // console.log('navigateToInviteFirstTime - Navigating to ecosystem');
      setTimeout(() => {
        navigateTo(Pathname.authentication.ecosystem);
        localStorage.removeItem('pendingSingleUpload');
      }, 100);
      localStorage.setItem('inviteUser', 'true');
    }
  };

  useEffect(() => {
    const uploadVideoAndSignIn = async () => {
      const shouldProcess = addVideoUpdater[fetchDraftID] === true
        && isS3UploadComplete[fetchDraftID] === true
        && !processedDraftIdsRef.current.has(fetchDraftID);

      if (shouldProcess) {
        processedDraftIdsRef.current.add(fetchDraftID);

        const category_id = draftCategoryState[fetchDraftID]?.category_id;
        const category_name = draftCategoryState[fetchDraftID]?.category_name;
        const thumbnailx = draftCategoryState[fetchDraftID]?.thumbnailx;
        const customThumbnails = draftCategoryState[fetchDraftID]?.customThumbnails;
        const title = draftCategoryState[fetchDraftID]?.title;
        const subcategory_id = draftCategoryState[fetchDraftID]?.subcategory_id;
        const thumbnail_list = draftCategoryState[fetchDraftID]?.thumbnail_list;
        const visibility = draftCategoryState[fetchDraftID]?.visibility;
        const description = draftCategoryState[fetchDraftID]?.description;
        const videoWidth = draftCategoryState[fetchDraftID]?.videoWidth;
        const videoHeight = draftCategoryState[fetchDraftID]?.videoHeight;
        const videoOreintation = draftCategoryState[fetchDraftID]?.videoOreintation;
        const playlist_ids = draftCategoryState[fetchDraftID]?.playlist_ids;
        const video_duration = draftCategoryState[fetchDraftID]?.video_duration;
        const group_ids = draftCategoryState[fetchDraftID]?.videoGroup;

        category_id && formData.append('category_id', category_id);
        if (category_name) {
          formData.append('category_name', category_name);
        }
        formData.append('title', title);
        subcategory_id && formData.append('subcategory_id', subcategory_id);
        formData.append('visibility', visibility);
        formData.append('description', description);
        formData.append('videoWidth', videoWidth);
        formData.append('videoHeight', videoHeight);
        formData.append('videoOreintation', videoOreintation);
        formData.append('playlist_ids', playlist_ids);
        formData.append('video_duration', video_duration);
        formData.append('group_ids', group_ids);
        try {
          if (thumbnailx !== noPhotoAvailable && customThumbnails?.length > 0) {
            formData.append('thumbnails[]', base64ToBinary(thumbnailx));
          }
          if (thumbnailx !== noPhotoAvailable) {
            formData.append('thumbnail', base64ToBinary(thumbnailx));
          }
        } catch (error) {
          console.error(error.message);
        }
        if (
          customThumbnails?.length > 0
          && thumbnailx !== customThumbnails[0]
        ) {
          formData.append('thumbnails[]', base64ToBinary(customThumbnails[0]));
        }

        thumbnail_list.forEach((file, index) => {
          formData.append(
            'thumbnails[]',
            file,
            `thumbnail_${index + (customThumbnails?.length > 0 ? 2 : 1)}.jpg`
          );
        });
        try {
          await addVideo(formData);
          setUploadContainer2((prev) => prev?.filter((id) => id !== fetchDraftID));
          await autoSignIn();
          // Use pre-upload count from localStorage (stored when upload started)
          const preUploadCount = parseInt(localStorage.getItem('preUploadCount') || '0', 10);
          navigateToInviteFirstTime(preUploadCount);
          localStorage.removeItem('preUploadCount');
          setS3UploadComplete((prev) => ({ ...prev, [fetchDraftID]: false }));
          updateUploadedData(fetchDraftID, 'completed');
        } catch (error) {
          console.error('Error during upload or sign-in:', error);
        }
      }
    };

    uploadVideoAndSignIn();
  }, [addVideoUpdater[fetchDraftID], isS3UploadComplete[fetchDraftID]]);

  const { isValidating: gettingUserConnections, mutate: getUserConnections } = useSWR([endpoints.getAllViewRequestSent, 1], {
    fetcher: (url, status) => dataFetcher(url, { status }),
    onSuccess: ({ success, data }) => {
      if (success) {
        setUserConnections(data);
      } else {
        setUserConnections([]);
      }
      setloadingForAccess(false);
    },
    onError: () => {
      setUserConnections([]);
      setloadingForAccess(false);
    },
  });
  const [toastForGroup, setToastForGroup] = useState('');
  const [subscriptionDetails, setSubscriptionData] = useState();
  const [subDetails, setSubDetails] = useState();
  const [langText, setLangText] = useState(undefined);
  const [mangerFunctionData, setmangerFunctionData] = useState(false);
  const [messaged, setmessaged] = useState('');
  const [referralStatus, setReferralStatus] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const browserLang = detectBrowserLanguage();
  const [showProgressBox, setProgressBox] = useState(false);
  const [uploadingVideo, setUploadingVideo] = useState([]);
  const [uploadingVideoDetails, setUploadingVideoDetails] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(undefined);
  const [uploadStatus, setUploadStatus] = useState(undefined);
  const [showDownloadBox, setDownloadBox] = useState(false);
  const [downloadingFiles, setDownloadingFiles] = useState([]);
  const [downloadBatchProgress, setDownloadBatchProgress] = useState({ current: 0, total: 0 });
  // Download cancel/pause state
  const [downloadAbortControllers] = useState(new Map());
  const [pausedDownloads] = useState(new Set());
  const downloadAbortControllersRef = useRef(new Map());
  const pausedDownloadsRef = useRef(new Set());
  const resumeTriggersRef = useRef(new Map()); // Map of videoId -> resume function
  const bulkDownloadCancelRef = useRef(false); // Ref to signal bulk download cancellation
  const setBulkDownloadingRef = useRef(null); // Ref to setIsBulkDownloading from YourVideos
  const onDownloadPanelVisibleRef = useRef(null); // Ref to callback when download panel becomes visible
  const [visibility, setVisibility] = useState(true);
  const [videoDetail, setVideoDetail] = useState(undefined);
  const [startFlowEvent, startingFlowEvent] = useState(false);
  const [profileLoader, setProfileLoader] = useState(false);
  const [isSingleUpload, setSingleUpload] = useState(undefined);
  const [closeModal, setModalVisibility] = useState(false);
  const [uniqueId, setUniqueId] = useState(undefined);
  const [pageLoad, setPageLoad] = useState(false);
  const [videoCount, setVideoCount] = useState(0);
  const [refreshContent, setRefreshContent] = useState(false);
  const [errorMsg, setErrorMsg] = useState(undefined);
  const [selectedUploadFiles, setSelectedUploadFiles] = useState([]);
  const [s3Data, setS3Data] = useState({});
  const [uploadPercentages, setUploadPercentages] = useState([]);
  const [lineReq, setLineReq] = useState(false);
  const [apiCALL, setapiCALL] = useState(undefined);
  const [uploadingInProgress, setUploadingInProgress] = useState(null);
  const [toastVisiblity, setToastVisiblity] = useState(true);
  const [pubLoader, setPubLoader] = useState(false);
  const [iamUploading, setIamUploading] = useState(false);
  const [bigUserData, setbigUserData] = useState({});
  const [textOfUpload, settextOfUpload] = useState('Publish');
  const [invalidErr, setinvalidErr] = useState();
  const [isAddDraftDone, setisAddDraftDone] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [helpNeed, setHelpNeed] = useState(false);
  const [dataOfCategory, setdataOfCategory] = useState();
  const [profileName, setProfileName] = useState();
  const [contextLoading, setContextLoading] = useState(false);
  const [singleEdit, setSingleEdit] = useState(false);
  const [amICalled, setamICalled] = useState(false);
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(false);
  const [photoAlbumLoader, setphotoAlbumLoader] = useState(false);
  const [needToShowETA, setNeedToShowETA] = useState(false);
  const [theGrtLoader, settheGrtLoader] = useState(false);
  const [categoryLoader, setcategoryLoader] = useState(undefined);
  const uploadDataPercentages = useSelector((state) => state.upload);
  const [cardNumber, setCardNumber] = useState('');
  const [screatId, setScreatId] = useState('');
  const [cvvNumber, setCvvNumber] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  const [firstTimeOnlychecked, setFirstTimeOnlyChecked] = useState(false);
  const [cardAdded, setcardAdded] = useState(false);
  const [isTrail, setIsTrail] = useState('0');
  const [uploadQueue, setUploadQueue] = useState([]);
  const [activeUploads, setActiveUploads] = useState([]);
  const [draftOfUpload, setDraftOfUpload] = useState([]);
  const [totalDraft, setTotalDraft] = useState([]);
  const [allvideoData, setAllvideoData] = useState([]);
  const [activeModalId, setActiveModalId] = useState(null);
  const [isUploadingBulky, setIsUploadingBulky] = useState(false);
  const [uploadProcessing, setUploadProcessing] = useState(false);
  const [disableDrag, setdisableDrag] = useState(false);
  const [didIOpenModal, setdidIOpenModal] = useState(false);
  const [openPaymentSuccess, setOpenPaymentSuccess] = useState(false);
  const [openPaymentLoader, setOpenPaymentLoader] = useState(false);
  const [photoList, setPhotoList] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [overlay, setOverlay] = useState(false);
  const [trailVideos, setTrailVideos] = useState(10);
  const [trailModalVisible, setTrailPopUpModalVisible] = useState(false);
  const [selectedPlan, selectPlan] = useState(undefined);
  const [isFromAffl, setisFromAffl] = useState(false);
  const [affliatePlanId, setAffliatePlanId] = useState(11);
  const [expressloading, setExpressLoading] = useState(false);
  const [uploadType, setUpdateType] = useState(undefined);
  const [tabTitle, setTabTitle] = useState(
    parseInt(window.sessionStorage.getItem('tabTitle'), 10) || 0
  );

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const IsfreePlan = subscriptionDetails?.plans?.length > 0 ? subscriptionDetails.plans[subscriptionDetails.plans.length - 1]?.plan_id === '6' : subscriptionDetails?.subscription === null;
  const MAX_VIDEOS = subscriptionDetails?.subscription?.is_trial === '1' ? trailVideos : 100;
  const MAX_PHOTOS = 100;
  const storageUsedMb = subscriptionDetails?.storageUsed1 || 0; // in MB
  const freePlanLimitMb = 5 * 1024; // 5GB in MB
  const proPlanLimitMb = 30 * 1024; // 30GB in MB

  const remainingMb = IsfreePlan
    ? freePlanLimitMb - storageUsedMb
    : proPlanLimitMb - storageUsedMb;

  const MAX_SIZE_GB = parseFloat((remainingMb / 1024).toFixed(2));
  const MAX_SIZE_BYTES = MAX_SIZE_GB * 1024 * 1024 * 1024;
  const allowedExtensions = ['mp4', 'mov', 'mpg', 'm4v', 'm2ts'];
  const hasReachedStorageLimit = subscriptionDetails?.storageUsed?.total_storage >= freePlanLimitMb;
  // console.log('hasReachedStorageLimit', subscriptionDetails?.storageUsed?.total_storage, freePlanLimitMb);
  useEffect(() => {
    // Combine all `draft_id`s from `allvideoData`, default to empty arrays if undefined
    const allDraftIds = [
      ...(allvideoData?.video?.map((item) => item?.draft_id) || []),
      ...(allvideoData?.videoDraftContents?.map((item) => item?.draft_id)
        || []),
    ];
    // Filter out matching `draft_id`s from `draftOfUpload`
    setDraftOfUpload((prevDrafts) => prevDrafts?.filter((draftId) => !allDraftIds?.includes(draftId)));
    setTotalDraft(allDraftIds);
  }, [allvideoData]);

  const setLoadingState = (isLoading) => {
    setContextLoading(isLoading);
  };
  const updateUploadPercentages = (uploadPercentages) => {
    setUploadPercentages(uploadPercentages);
  };
  useEffect(() => {
    if (userDetails?.totalContentUploaded !== undefined) {
      const remainingUploads = Math.max(
        10 - (uploadContainer2?.length + userDetails?.totalContentUploaded),
        0
      );
      setTrailVideos(remainingUploads);
    }
  }, [userDetails?.totalContentUploaded, uploadContainer2]);
  const { isValidating: gettingVideoIdFromFlow, mutate: getVideoIdFromFlow } = useSWR([endpoints.getVideoIdFromFlow, uniqueId], {
    fetcher: (url, flowIdentifier) => dataFetcher(url, { flowIdentifier }),
    onSuccess: ({ success, video_id }) => {
      if (success) {
        const copyVideo = [...uploadingVideoDetails];
        const foundIndex = copyVideo.findIndex(
          (x) => x.fileId === uniqueId && x.id === null
        );
        if (foundIndex !== -1 && video_id) {
          copyVideo[foundIndex] = { ...copyVideo[foundIndex], id: video_id };
          // setUploadingVideoDetails(copyVideo);
        }
      } else {
        // setUserConnections([]);
      }
    },
    onError: () => {
      setUserConnections([]);
    },
  });

  useEffect(() => {
    if (!plansLoading && plansRes && plansRes?.data) {
      setAllPlans(plansRes?.data);
    }
  }, [plansRes, plansLoading]);

  // useEffect(() => {
  //   if (videoDetail) {
  //     setUploadingVideoDetails([...uploadingVideoDetails, videoDetail]);
  //     setVideoDetail(undefined);
  //   }
  // }, [videoDetail]);

  // useEffect(() => {
  //   const currentVideo = uploadingVideoDetails.find((x) => x.fileId === uniqueId);
  //   if (!currentVideo?.id && uniqueId) {
  //     getVideoIdFromFlow();
  //   }
  // }, [uploadingVideoDetails, uniqueId]);

  useEffect(() => {
    if (
      uploadingVideoDetails?.length
      && videoCount
      && !uploadingVideoDetails.filter((v) => v.id === null)?.length
    ) {
      setProgressBox(true);
      setModalVisibility(true);
      setVideoCount(0);
    } else {
      setModalVisibility(false);
    }
  }, [uploadingVideoDetails, videoCount]);
  useEffect(() => {
    if (uploadProgress) {
      const copyVideo = [...uploadingVideoDetails];
      const foundIndex = copyVideo.findIndex(
        (x) => x.fileId === uploadProgress.fileId
      );
      if (foundIndex !== -1) {
        copyVideo[foundIndex] = {
          ...copyVideo[foundIndex],
          progress: uploadProgress.progress,
          status: 'Uploading',
        };
        setUploadingVideoDetails(copyVideo);
      }
    }
  }, [uploadProgress]);
  useEffect(() => {
    if (isSingleUpload) {
      setUploadingVideoDetails([]);
    }
  }, [isSingleUpload]);

  useEffect(() => {
    if (uploadStatus) {
      const { progress, status, size, id, videoDuration, suggestedThumbnails } = uploadStatus;
      const copyVideo = [...uploadingVideoDetails];
      const foundIndex = copyVideo.findIndex(
        (x) => x.fileId === uploadStatus.fileId
      );
      if (foundIndex !== -1) {
        copyVideo[foundIndex] = {
          ...copyVideo[foundIndex],
          progress,
          status,
          size,
          id,
          videoDetail,
          suggestedThumbnails,
          videoDuration,
        };
        setUploadingVideoDetails(copyVideo);
      }
    }
  }, [uploadStatus]);

  const updateVideoDetails = (file, uniqueIdentifier) => {
    const newVideo = {
      progress: '0%',
      name: file.name,
      size: parseFloat((file.size / 1048576).toFixed(2)),
      fileId: uniqueIdentifier,
      status: 'Uploading',
      boxVisibility: 1,
      id: null,
      description: '',
      published: 0,
    };
    setUploadingVideoDetails((prevDetails) => [...prevDetails, newVideo]);
  };
  // TODO remove flowEventHandler completely
  const flowEventHandler = () => {
    setModalVisibility(false);
    const flow = new window.Flow({
      target: `${baseUrl?.URL}${endpoints.addVideoContentArray}`,
      testChunks: false,
      query: {
        token: getToken(),
      },
      fileParameterName: 'video_file[]',
    });
    if (flow?.support) {
      flow.assignBrowse(document.getElementById('video-file'));
      flow.on('fileAdded', (file, evt) => {
        startingFlowEvent(false);
        const foundIndex = uploadingVideoDetails.findIndex(
          (x) => x.fileId === file.uniqueIdentifier
        );
        if (foundIndex !== -1) {
          flow.off();
          startingFlowEvent(false);
          setModalVisibility(true);
          setErrorMsg('Video already added');
        } else {
          setErrorMsg(undefined);
          setVideoDetail({
            progress: '0%',
            name: file.name,
            size: parseFloat((file.size / 1048576).toFixed(2)),
            fileId: file.uniqueIdentifier,
            status: 'Uploading',
            boxVisibility: 1,
            id: null,
            description: '',
            published: 0,
          });
          if (evt?.target?.files?.length === 1 && !showProgressBox) {
            setSingleUpload(file.file);
            flow.off();
          } else {
            setUniqueId(file.uniqueIdentifier);
          }
        }
      });
      flow.on('filesAdded', (array, event) => {
        setVideoCount(array?.length);
      });
      flow.on('filesSubmitted', (arr, evt) => {
        flow.upload();
      });
      flow.on('fileProgress', (file, chunk) => {
        setUniqueId(file.uniqueIdentifier);
        let videoProgress = ((chunk.offset + 1) / file.chunks.length) * 100;
        videoProgress = `${parseInt(videoProgress, 10)}%`;
        setUploadProgress({
          fileId: file.uniqueIdentifier,
          progress: videoProgress,
        });
        setProgressBox(true);
      });
      // (C6) ON UPLOAD SUCCESS
      flow.on('fileSuccess', (file, message, chunk) => {
        const resp = JSON.parse(message);
        setUploadStatus({
          fileId: file.uniqueIdentifier,
          status: 'Completed',
          progress: '100%',
          id: resp?.video_id,
          videoDuration: resp?.video_duration,
          size: resp?.video_size,
          suggestedThumbnails: resp?.suggestedThumbnails,
        });
      });
      // (C7) ON UPLOAD ERROR
      flow.on('fileError', (file, message) => {
        setUploadStatus({
          fileId: file.uniqueIdentifier,
          status: 'Error',
        });
      });
      // flow.isComplete(() => {
      // });
      flow.on('complete', (message, file, chunk) => { });
    }
  };

  /**
   * Uploadfiles called whenever selectedUploadFiles changes, whcih will be changes based on modal input selection
   * check for the selectedUploadFiles array wether contains one or more files, and if >1 show progress box with each files progress
   */
  const uploadFiles = useCallback(() => {
    setModalVisibility(false);
    let callMultipleApi = true;
    selectedUploadFiles.forEach((selectedFile) => {
      const { file } = selectedFile;
      const formData = new FormData();
      if (selectedUploadFiles?.length === 1 && !showProgressBox) {
        setSingleUpload(selectedUploadFiles[0]?.file);
        callMultipleApi = false;
      } else {
        setUniqueId(selectedFile.uniqueIdentifier);
      }

      const foundIndex = uploadingVideoDetails.findIndex(
        (x) => x.fileId === selectedFile.uniqueIdentifier
      );
      if (foundIndex !== -1) {
        setModalVisibility(true);
        setErrorMsg('Video already added');
        callMultipleApi = false;
      } else {
        setErrorMsg(undefined);
        updateVideoDetails(file, selectedFile.uniqueIdentifier);
        formData.append('video_file[]', file);
      }
      if (callMultipleApi) {
        setVideoCount(1);
        setProgressBox(true);
        axios
          .post(`${baseUrl?.URL}${endpoints.addVideoContentArray}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: getToken(),
            },
            onUploadProgress: (progressEvent) => {
              const { loaded, total } = progressEvent;
              const percent = Math.floor((loaded * 100) / total);
              setUploadProgress({
                fileId: selectedFile.uniqueIdentifier,
                progress: `${percent} %`,
              });
            },
          })
          .then((res) => {
            setUploadStatus({
              fileId: selectedFile.uniqueIdentifier,
              status: 'Completed',
              progress: '100%',
              id: res?.data?.video_id,
              videoDuration: res?.data?.video_duration,
              size: res?.data?.video_size,
              suggestedThumbnails: res?.data?.suggestedThumbnails,
            });
          })
          .catch((error) => {
            setUploadStatus({
              fileId: selectedFile.uniqueIdentifier,
              status: 'Error',
            });
          });
      }
    });
  }, [selectedUploadFiles]);
  const { isValidating: gettingSubscription, mutate: getSubscription } = useSWR(
    [endpoints.getMySubscription],
    {
      fetcher: (url) => dataFetcher(url),
      onSuccess: (response) => {
        if (response.success) {
          const { subscription, planaction } = response;
          setSubDetails({ ...response });
          setInActiveUser(
            (!response?.has_activePlan
              && (response.expired || response.subscription !== null))
            || (response?.has_activePlan
              && parseInt(response?.subscription?.subscription_status, 10) === 2)
          );
          setReferralStatus(response?.referral_status);
        } else {
          setSubDetails({ subscription: { plan: 'Free' } });
        }
      },
      onError: () => {
        setSubDetails({ subscription: { plan: 'Free' } });
      },
    }
  );
  useEffect(() => {
    if (selectedUploadFiles.length > 0) {
      uploadFiles();
    }
  }, [selectedUploadFiles, uploadFiles]);
  // useEffect(() => {
  //   if (startFlowEvent) {
  //     flowEventHandler();
  //   }
  // }, [startFlowEvent]);
  const [stripeUiSelector, setStripeUiSelector] = useState();
  const [checked, setChecked] = useState(false);
  const clearChecked = () => {
    setChecked(false);
    setFirstTimeOnlyChecked(false);
  };
  const [expressData, setExpressData] = useState();
  const [planPurchasing, setPlanPurchasing] = useState(false);
  const expressCheckout = async (
    Id,
    plan_id = localStorage.getItem('planId'),
    closeAddCard,
    managerTokenParam = null
  ) => {
    setOpenPaymentLoader(true);
    const userData = apiCALL?.data?.userDetails[0] || bigUserData;
    const userId = userData?.id || userData?.userId || localStorage.getItem('temp_user_id');
    try {
      const myToken = await getToken();
      // When manager is accessing a user and paying with manager's card, use manager's token passed as param
      const tokenForPurchase = managerTokenParam || myToken;
      const apiUrl = `${baseUrl}/${endpoints.addPlanV2}`;
      const requestBody = {
        promo: localStorage.getItem('promocode'),
        ...(localStorage.getItem('affiliate') !== 'undefined' && {
          affiliateCode: localStorage.getItem('affiliate'),
        }),
        token: tokenForPurchase,
        ...(localStorage.getItem('affiliate') !== 'undefined'
          && localStorage.getItem('firstTimeOnlychecked') === 'true'
          ? { only_first_year: true }
          : { only_first_year: false }),
        plan_id,
        is_free: 0,
        ...(isFromAffl && {
          managerCard: localStorage.getItem('managerCard') === '1',
        }),
        //  ...(isFromAffl && { userId: localStorage.getItem('affliate_userId') }),
        ...(localStorage.getItem('affiliate') !== 'undefined' && {
          userId: localStorage.getItem('affliate_userId'),
        }),
        trial: localStorage.getItem('trial') === '1',
        ...(Id && { checkout_id: Id }),
      };
      // Use fetch when manager token is provided to bypass axios interceptor
      let response;
      if (managerTokenParam) {
        const fetchResponse = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        });
        response = { data: await fetchResponse.json() };
      } else {
        response = await axios.post(apiUrl, requestBody);
      }
      console.log('Express Checkout Response:', response.data);

      if (window.gtag) {
        window.gtag('event', 'purchase', {
          transaction_id: new Date().getTime().toString(), // or use your own unique ID if available
          value: 0, // Trial = free (change if user paid)
          currency: 'USD', // Change to your actual currency
          coupon: '', // If any coupon applied
          items: [
            {
              item_id:
                response.data?.plan_name?.toLowerCase().replace(/\s+/g, '_')
                || 'subscription',
              item_name: response.data?.plan_name || 'Subscription Plan',
              price: response.data?.value,
              quantity: 1,
              trial: response.data?.isTrial,
              trial_duration: response.data?.plan_trial_duration,
              plan_duration: response.data?.plan_duration,
              start_date: new Date().getTime().toString(),
            },
          ],
        });
      }

      setExpressData(response?.data);
      setAppSnackbar({
        isVisible: true,
        type: 'success',
        message: response?.data?.message,
      });
      if (localStorage.getItem('affliate_userId')) {
        setPaymentStatus('affliate');
      } else {
        setPaymentStatus('success');
      }
      setOpenPaymentSuccess(true);
      getSubscription();
      autoSignIn();
      setExpressLoading(false);
      // Navigate to dashboard when manager is accessing user after successful plan purchase
      // Show success popup first, then navigate after delay so user sees it
      if (managerTokenParam) {
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 2000);
        return;
      }
      localStorage.removeItem('promocode');
      localStorage.removeItem('affiliate');
      localStorage.removeItem('trial');
      localStorage.removeItem('affliate_userId');
      localStorage.removeItem('managerCard');
      localStorage.removeItem('firstTimeOnlychecked');
      //  localStorage.removeItem('planId');
      setTimeout(() => {
        closeAddCard && closeAddCard();
        setPlanPurchasing(false);
      }, 2000);
      localStorage.setItem('tutorialCloud', true); // Set tutorialCloud to true to show tutorial modal when enetering in cloud
    } catch (err) {
      //  setTimeout(() => {
      //          closeAddCard();
      //      setPlanPurchasing(false);
      //  }, 2000);
      setOpenPaymentLoader(false);
      const responseData = err?.response?.data?.message || err?.message;
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Purchase Plan',
        description: 'Plan purchase failed at app level',
        severity: 'high',
        errorMessage: responseData || 'Plan purchase failed',
        responseStatus: err?.response?.status || null,
        responseBody: err?.response?.data ? JSON.stringify(err.response.data) : null,
        requestUrl: `${baseUrl}/${endpoints.addPlanV2}`,
        requestMethod: 'POST',
        component: 'App',
        userAction: 'Purchase plan called',
      });
      localStorage.removeItem('promocode');
      localStorage.removeItem('affiliate');
      localStorage.removeItem('trial');
      localStorage.removeItem('managerCard');
      localStorage.removeItem('planId');
      setExpressLoading(false);
      if (localStorage.getItem('affliate_userId')) {
        setPaymentStatus('affliate_error');
      } else {
        setPaymentStatus('error');
      }
      localStorage.removeItem('affliate_userId');
      autoSignIn();
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message:
          responseData || 'Oops! Something went wrong while purchasing plan',
      });
    }
  };
  useEffect(() => {
    if (
      localStorage.getItem('token') === null
      && window.location.pathname === '/'
      && window.location.origin !== 'http://localhost:3000'
      && window.location.origin !== 'https://preprod.projector.app'
    ) {
      window.location.href = 'https://www.projectorstream.com';
    } else if (
      window.location.pathname.includes('success-payment')
      && new URLSearchParams(window.location.search).get('checkout_id')
    ) {
      const params = new URLSearchParams(window.location.search);
      const id = params.get('checkout_id');
      setTimeout(() => {
        expressCheckout(id);
      }, 100);
    } else if (window.location.pathname.includes('cancel')) {
      localStorage.removeItem('code');
    }
  }, []);
  useEffect(() => {
    if (subDetails && subDetails !== subscriptionDetails) {
      setSubscriptionData(subDetails);
    }
  }, [subDetails]);

  const { isValidating: gettingLangFile, mutate: getLanguageFile } = useSWR(
    [endpoints.getLangFile, browserLang],
    {
      fetcher: (url, lang) => dataFetcher(url, { lang }),
      onSuccess: (response) => {
        if (response.success) {
          setLangText(JSON.parse(response.data));
        } else {
          setLangText(undefined);
        }
      },
      onError: () => {
        setLangText(undefined);
      },
    }
  );
  const defaultCategoryName = 'All Videos';
  const [mangerToken, setMangerToken] = useState();
  const [topOrBottom, setTopOrBottom] = useState(true);
  const [userAccessedData, setuserAccessedData] = useState();
  const [managerPrivatePlanAccess, setManagerPrivatePlanAccess] = useState(false);
  const [managerPaymentMethods, setManagerPaymentMethods] = useState([]);
  const [apiResponse, setApiResponse] = useState();
  const [trialVal, setTrial] = useState(undefined);
  const [cardPayId, setcardPayId] = useState();
  const [cardUpdate, setcardUpdate] = useState(false);
  const [allowedEmails, setAllowedEmails] = useState();
  const [cardUpdateBoolean, setcardUpdateBoolean] = useState(false);
  const daysOfMonths = '30';
  const [isTokenChange, setIsTokenChange] = useState(false);
  const [affiliateCode, setAffiliatedCode] = useState('');
  const [encounterLoading, setEncounterLoading] = useState(false);
  const handleClick = (e) => {
    // Store manager's private_plan_access before switching to accessed user
    const currentUserPrivatePlanAccess = apiResponse?.data?.[0]?.private_plan_access;
    if (currentUserPrivatePlanAccess === '1' || currentUserPrivatePlanAccess === 1) {
      setManagerPrivatePlanAccess(true);
    }
    // Store manager's token before switching
    setMangerToken(getToken());
    // Store manager's payment methods before switching
    setManagerPaymentMethods(subscriptionDetails?.paymentMethods || []);
    setuserAccessedData(e);
    const newToken = e.token;
    setToken(newToken);
    setIsTokenChange(true);
    // Clear inviteUser flag when switching to accessed user's account
    localStorage.removeItem('inviteUser');
  };
  const handleManger = (e) => {
    // Clear manager's private_plan_access when returning to manager's own account
    setManagerPrivatePlanAccess(false);
    setMangerToken(null);
    setManagerPaymentMethods([]);
    setuserAccessedData(null);
    const newToken = e?.data?.manager_token;
    setToken(newToken);
    // Clear inviteUser flag when returning to manager's account
    localStorage.removeItem('inviteUser');
  };

  // Manager user switching function
  const switchingFunction = async (obj) => {
    try {
      const formData = new FormData();
      formData.append('token', getToken());
      formData.append('user_id', obj.id);
      formData.append('user_token', obj.token);
      const response = await axios.post(`${baseUrl}/managerUserLogs`, formData);
      if (response?.data?.success === true) {
        // Clear all dummy/temporary data from Redux store
        // (dispatch would need to be added if not using from component)
        handleClick(obj);
        localStorage.setItem('firstname', obj?.firstname || '');
        localStorage.setItem('lastname', obj?.lastname || '');
        navigateTo('/dashboard');
        getSubscription();
        autoSignIn();
        return { success: true };
      }
      setmessaged(response?.data?.message);
      setmangerFunctionData(true);
      return { success: false, message: response?.data?.message };
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  };

  /**
   * Get user profile using token as payload
   */
  const fetchWhitelistedEmails = async () => {
    try {
      const response = await axios.get(
        `${cloudBaseUrl}/user/whitelisted-emails/`
      );
      setAllowedEmails(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching whitelisted emails:', error);
      throw error;
    }
  };
  useEffect(() => {
    // fetchWhitelistedEmails();
  }, []);
  const isEmailAllowed = allowedEmails?.results?.some(
    (item) => item?.email?.toLowerCase() === userDetails?.email?.toLowerCase()
  );
  const forceAutoSignin = () => {
    setAutoSignIn(true);
    autoSignIn();
  };

  useEffect(() => {
    const detectBrowserLanguage = require('detect-browser-language');
    getLanguageFile();
    const htmlClass = document.getElementsByTagName('html')[0].classList;

    window.onresize = () => {
      htmlClass.add(styles.changingTheme);
      setTimeout(() => htmlClass.remove(styles.changingTheme), 500);
    };
  }, []);

  useEffect(() => {
    const token = getToken();
    const isEmailVerified = getEmailVerified();
    if (token) {
      setAutoSignIn(true);
      autoSignIn();
    } else {
      setAutoSignIn(false);
    }
  }, [autoSignIn]);
  const [isLoading, setIsLoading] = useState(true);
  const fetchData = async () => {
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/affiliateDetails`;
      const requestBody = {
        token: myToken,
      };
      const response = await axios.post(apiUrl, requestBody);
      setApiResponse(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (userIsSignedIn) {
      setloadingForAccess(true);
      getUserConnections();
      getSubscription();
    }
  }, [userIsSignedIn, getUserConnections]);
  const referralCode = localStorage.getItem('code');
  const [holdTheWeb, setHoldTheWeb] = useState(false);
  const disableScroll = () => {
    const scrollPosition = window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%'; // Set width to 100%
  };
  const enableScroll = () => {
    const scrollPosition = parseInt(document.body.style.top || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, -scrollPosition);
  };
  useEffect(() => {
    holdTheWeb === true ? disableScroll() : enableScroll();
  }, [holdTheWeb]);
  const [uploadPercentagesInNumber, setUploadPercentagesInNumber] = useState();
  const [droper, setDroper] = useState(false);
  const [videoFiles, setVideoFiles] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [pendingVideoFile, setPendingVideoFile] = useState(null);
  const [pendingPhotoFiles, setPendingPhotoFiles] = useState(null);
  const [addMorePhoto, setaddMorePhoto] = useState(false);
  const [uploadModalIsVisible, setUploadModalVisibility] = useState(false);
  const [popUpModalVisible, setPopUpModalVisible] = useState(false);
  const [openNewUploadModal, setOpenNewUploadModal] = useState(false);
  const [openPhotoUploadModal, setOpenPhotoUploadModal] = useState(false);
  // Cloud photo album modal state (persists across navigation)
  const [photoAlbumModalOpen, setPhotoAlbumModalOpen] = useState(false);
  const [pendingCloudPhotos, setPendingCloudPhotos] = useState([]);
  const [pendingCloudPhotoService, setPendingCloudPhotoService] = useState(null);
  const [showMultipleModal, setShowMultipleModal] = useState(false);
  const [showAddPlaylistModal, setShowAddPlaylistModal] = useState(false);
  const [showAddSubCategoryModal, setShowAddSubCategoryModal] = useState(false);
  const [selectedFilesMulti, setSelectedFilesMulti] = useState([]);
  const [buttonText, setButtonText] = useState('Publish');
  const [navigateOnceClicked, setNavigateOnceClicked] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [profileDetails, setProfileDetails] = useState({
    firstname: undefined,
    lastname: undefined,
    email: undefined,
    image: undefined,
    type: undefined,
  });
  const [open, setOpen] = useState(false);
  const [openX, setOpenX] = useState(false);
  const [cloudToken, setCloudToken] = useState();
  const [categoryDetails, setCategoryDetails] = useState();
  const [albumDetails, setAlbumDetails] = useState();
  const [chooseAlbumStep, setChooseAlbumStep] = useState(0);
  const [loginWithSocial, setLoginWithSocial] = useState(false);
  const [findAllVideoCategory, setFindAllVideoCategory] = useState({
    value: '', name: defaultCategoryName,
  });
  const [selectedItemsInBulk, setSelectedItemsInBulk] = useState(Array(videoFiles?.length).fill({
    token: getToken(),
    group_ids: [],
    draftId: '',
    thumbnails: '',
    name: '',
    description: '',
    category: '',
    categoryName: '',
    playlist: [],
    visibility: '2',
    size: '',
  }));
  const handleOpen = () => setOpen(true);
  const handleOpenX = () => setOpenX(true);
  const handleSingleDrop = () => {
    setDroper(false);
    // setCrossDrag(false);
  };
  const revealUploadModal = (videoFiles) => {
    const totalSize = (videoFiles?.reduce((acc, file) => acc + file.size, 0) || 0) / (1024 * 1024);
    localStorage.setItem('opened_draft_id', null);
    autoSignIn().then((res) => {
      if (
        !res?.data?.subscription
        && res?.data?.totalContentUploaded >= ALLOWED_UPLOADS_COUNT
      ) {
        setPopUpModalVisible(true);
        setEditLoader(false);
        setOpen(false);
      } else {
        setUploadModalVisibility(true);
        setEditLoader(false);
      }
    });
    const invalidFiles = videoFiles.filter((file) => {
      const extension = file.name.split('.').pop().toLowerCase();
      return !allowedExtensions.includes(extension);
    });
    if (invalidFiles.length > 0) {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message:
          'Invalid file format. Allowed formats are: .mp4, .mov, .mpg, .m4v, .m2ts',
      });
      // alert('Invalid file format. Allowed formats are: .mp4, .mov, .mpg, .m4v, .m2ts');
      return;
    }
    if (userDetails?.isSubscription === null) {
      const remainingUploads = ALLOWED_UPLOADS_COUNT - userDetails?.totalContentUploaded;
      if (
        videoFiles?.length <= remainingUploads
        && totalSize <= MAX_SIZE_BYTES
        && remainingUploads > 0
      ) {
        handleOpen();
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: `${remainingUploads} free upload allowed`,
        });
        setPopUpModalVisible(true);
      }
    } else if (userDetails?.isSubscription !== null) {
      if (videoFiles?.length <= MAX_VIDEOS && totalSize <= proPlanLimitMb) {
        handleOpen();
      } else {
        const errorMessage = videoFiles?.length > MAX_VIDEOS
          ? `Maximum of ${MAX_VIDEOS} videos allowed`
          : `Total size of videos should not exceed ${MAX_SIZE_GB}`;
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: errorMessage,
        });
        console.log('totalSize', totalSize, MAX_SIZE_BYTES, proPlanLimitMb);
      }
    }
  };
  const paymentNavigation = (route) => {
    setOpenPaymentSuccess(false);
    navigateTo(route);
  };
  const dragOver = (e) => {
    e.preventDefault();
    setDroper(true);
  };
  const dragLeave = (e) => {
    e.preventDefault();
    setDroper(false);
  };
  const hideUploadModal = () => {
    setUploadModalVisibility(false);
  };
  const backendUrl = 'https://backend.projectorstream.com';
  // if (
  //   window.location.origin.includes('localhost')
  //   || window.location.origin.includes('preprod')
  // ) {
  //   backendUrl = 'https://preprod.backend.projector.app';
  // }
  const [orderArrange, setOrderArrange] = useState([]);
  const fetchLayoutOrder = async (profileID) => {
    try {
      const response = await axios.post(`${backendUrl}/getLayoutOrder`, {
        userId: profileID,
        token: getToken(),
      });

      console.log('Layout Order Response:', response.data);
      setOrderArrange(response.data.data);
    } catch (error) {
      console.error('Error fetching layout order:', error);
    }
  };

  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [cardExpiryDialog, setCardExpiryDialog] = useState(false);
  const [fromLogin, setFromLogin] = useState(false);
  function isCardExpiringSoon(exp_month, exp_year) {
    const expiryDate = new Date(exp_year, exp_month, 0);
    const warningDate = new Date(expiryDate);
    warningDate.setDate(expiryDate.getDate() - 7);
    const today = new Date();
    return today >= warningDate;
  }
  const expiryDateChecker = subDetails?.paymentMethods?.length > 0
    && subDetails?.paymentMethods?.find(
      (card) => card?.id === subDetails?.default_payment_methods
    )?.card;
  const isGettingValidSub = subDetails?.paymentMethods?.length === 0;
  // || isCardExpiringSoon(
  //   expiryDateChecker?.exp_month,
  //   expiryDateChecker?.exp_year
  // );
  const expCheck = isCardExpiringSoon(
    expiryDateChecker?.exp_month,
    expiryDateChecker?.exp_year
  );
  useEffect(() => {
    const dismissed = localStorage.getItem('dismissedPaymentDialog');
    const isCardEXPshown = localStorage.getItem('cardEXPDialog');
    const isPaidPlan = !!subDetails?.subscription && subDetails?.subscription?.id !== '6';
    const isSpclPlan = !!subDetails?.subscription && subDetails?.subscription?.id !== '14';
    const isGiftPlan = !!subDetails?.subscription && !['15', '16'].includes(subDetails?.subscription?.id);
    const pathNameNotToShow = window.location.pathname === '/settings/manage-payment-methods';
    const searchParamsCheck = new URLSearchParams(window.location.search);
    const isGiftFlowPage = searchParamsCheck.get('gift') === 'true'
      || searchParamsCheck.get('fromGift') === 'true'
      || window.location.pathname === '/gift-content'
      || window.location.pathname === '/gift'
      || window.location.pathname === '/gift-payment'
      || window.location.pathname === '/receiving-gift'
      || (window.location.pathname === '/cloud-upload' && !!sessionStorage.getItem('giftFlowCloudConnect'));
    if (
      !dismissed
      && !isGiftFlowPage
      && getAccessChecker?.success !== true
      // && fromLogin
      && isPaidPlan
      && isSpclPlan
      && isGiftPlan
      && isGettingValidSub
    ) {
      setShowPaymentDialog(true);
    }
    setTimeout(() => {
      if (
        !isInActiveUser
        && !isGiftFlowPage
        && expCheck
        && !pathNameNotToShow
        && getAccessChecker?.success !== true
      ) {
        setCardExpiryDialog(true);
      }
    }, 100);
  }, [subDetails?.paymentMethods, window.location.pathname]);

  const handleCloseDialog = () => {
    localStorage.setItem('dismissedPaymentDialog', 'true');
    setShowPaymentDialog(false);
    setFromLogin(false);
    paymentNavigation('/settings/manage-payment-methods?add=true');
  };
  const handleCloseCardEXPDialog = () => {
    localStorage.setItem('cardEXPDialog', 'true');
    setCardExpiryDialog(false);
    paymentNavigation('/settings/manage-payment-methods?add=true');
  };
  const closeDialog = () => {
    if (isGettingValidSub && subDetails?.subscription !== null) {
      localStorage.setItem('dismissedPaymentDialog', 'true');
      setShowPaymentDialog(false);
      setFromLogin(false);
    }
  };
  // useEffect(() => {
  //   document.addEventListener('dragover', dragOver);
  //   document.addEventListener('dragleave', dragLeave);
  //   return () => {
  //     document.removeEventListener('dragover', dragOver);
  //     document.removeEventListener('dragleave', dragLeave);
  //   };
  // }, []);
  const MultiSelect = () => {
    setOverlay(false);
    const files = Array.from(selectedFiles);
    const videoFiles = files.filter((file) => file.type.startsWith('video/'));
    const imageFiles = files.filter((file) => file.type.startsWith('image/'));
    setVideoFiles(videoFiles);
    setImageFiles(imageFiles);
    revealUploadModal(videoFiles);
    setDroper(false);
  };
  useEffect(() => {
    if (selectedFiles?.length > 1) {
      MultiSelect();
    }
  }, [selectedFiles]);
  const handleDrop = (e) => {
    setOverlay(false);
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const videoFiles = files.filter((file) => file.type.startsWith('video/'));
    const imageFiles = files.filter((file) => file.type.startsWith('image/'));
    setVideoFiles(videoFiles);
    setImageFiles(imageFiles);
    revealUploadModal(videoFiles);
    setDroper(false);
  };
  // const [cardNumberStripe, setCardNumberStripe] = useState('');
  // const [inputValue, setInputValue] = useState('');
  // const [expiryMonth, setExpiryMonth] = useState('');
  // const [expiryYear, setExpiryYear] = useState('');
  // const [cvc, setCvc] = useState('');
  // const [stripeToken, setStripeToken] = useState([]);
  // const [error, setError] = useState(null);
  // const callStripeAPI = async () => {
  //   const datax = new URLSearchParams();
  //   datax.append('card[number]', cardNumberStripe);
  //   datax.append('card[exp_month]', expiryMonth);
  //   datax.append('card[exp_year]', expiryYear);
  //   datax.append('card[cvc]', cvc);
  //   try {
  //     const response = await axios.post('https://api.stripe.com/v1/tokens', data, {
  //       headers: {
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //         'Authorization': 'Bearer pk_live_51OyTOEKaFrbWdXakXgNskBU4TmXmqTIP6thT1vf8LjiR1FADapz2jX6Fi5a1h8KpG7hCAiEK9EnlrKbH7wDVGjOs00ReGilVdx',
  //       },
  //     });
  //     setStripeToken(response.data);
  //     setError(null);
  //   } catch (error) {
  //     setError(error.response?.data?.error?.message || 'Error occurred while contacting Stripe API');
  //     console.error('Error:', error);
  //   }
  // };
  useEffect(() => {
    if (navigateOnceClicked === true) {
      if (buttonText === 'Save to Draft') {
        navigateTo(`${Pathname.yourVideos}?tab=draft`);
      } else if (buttonText === 'Publish & Save' || buttonText === 'Publish') {
        navigateTo('/your-videos');
      }
    }
    setNavigateOnceClicked(false);
  }, [navigateOnceClicked]);
  const [storageSelectedType, setStorageSelectedType] = useState('name');
  const [storageSearchTerm, setStorageSearchTerm] = useState('');
  const [storageSelectedDate, setStorageSelectedDate] = useState('');
  const [storageTabTitle, setStorageTabTitle] = useState(0);
  const [storageSelectedItems, setStorageSelectedItems] = useState([]);
  const [videoThumbnails, setVideoThumbnails] = useState([]);
  const [videoThumbnails64, setVideoThumbnails64] = useState([]);

  const [activeTab, setActiveTab] = useState(0);
  const test = useSelector((state) => state.titleBulk);
  const [categoryRefreshTrigger, setCategoryRefreshTrigger] = useState(0);
  const [playlistRefreshTrigger, setPlaylistRefreshTrigger] = useState(0);
  const [newlyCreatedPlaylistId, setNewlyCreatedPlaylistId] = useState(null);
  const [newlyCreatedPlaylistTitle, setNewlyCreatedPlaylistTitle] = useState(null);
  const [subCategoryRefreshTrigger, setSubCategoryRefreshTrigger] = useState(0);
  const [newlyCreatedSubCategoryId, setNewlyCreatedSubCategoryId] = useState(null);

  // AWS S3 configuration
  AWS.config.update({
    region: awsConfig.region,
    accessKeyId: awsConfig.accessKey,
    secretAccessKey: awsConfig.secretKey,
  });
  AWS.config.httpOptions.timeout = 0;
  const s3 = new AWS.S3();

  // Helper variables for upload tracking
  const iteratorNum = [];
  const totalNum = [];
  let tempPercentages;

  // Get userId from userDetails
  const userId = userDetails?.isSubscription?.user_id;

  // Helper functions for upload process
  const updateUploadPercentagesModal = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };

  const closeToast = (draft_id, message, type) => {
    toast.update(draft_id, { closeButton: false, render: message, type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR, autoClose: 3000 });
    setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
  };
  const updateItem = (percentage, draft_id, filename, uploadPercentages, updateUploadPercentagesModal) => {
    const rawPercent = (percentage / totalNum[draft_id]) * 100;
    const percent = Math.floor(rawPercent);
    toast.update(draft_id, { progress: rawPercent / 100 });
    const newPercentages = { ...uploadPercentages, [draft_id]: percent };
    tempPercentages = newPercentages;
    updateUploadPercentagesModal(draft_id, percent);
  };

  function formatFileSizeAccMb(sizeInBytes) {
    const megabyte = 1024 * 1024;
    const sizeInMB = sizeInBytes / megabyte;
    return sizeInMB.toFixed(2);
  }
  async function sendVideoDataToServer(theGreatPayload, draft_id) {
    const apiUrl = `${baseUrl}/V6/addVideo`;
    try {
      const response = await axios.post(apiUrl, theGreatPayload);
      // fetchContents(); // You may need to implement this if needed
      closeToast(draft_id, 'Uploading completed', 'success');
      autoSignIn();
      setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => id !== draft_id));
    } catch (error) {
      console.error('Error sending video data:', error);
    }
  }

  const handleUploadClick = (draft_id) => {
    const dataUpdate = { [`${draft_id}/status`]: 'DELETED' };
    update(ref(firebaseDatabase, 'status_from_sns'), dataUpdate);
    updateUploadPercentagesModal(draft_id, 'Cancelled');
    closeToast(draft_id, 'Upload has been canceled by user', 'error');
  };
  const updateDummy = (dummy, status = 0) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const handleEncouter = (draft_id) => {
    if (uploadQueue?.length <= 1) {
      if (photoList && photoList?.length > 0) {
        setActiveTab(1); // Switch to photo tab
      } else {
        setOpen(false); // Close modal only if no photos
      }
    }
    toast.update(draft_id, {
      closeButton: <CustomCloseloader />,
    });

    const databaseRef = ref(firebaseDatabase, 'status_from_sns');
    const changeFieldFromFirebase = (draft_id, statusString) => {
      const dataToUpdate = {
        [draft_id]: {
          status: statusString,
        },
      };
      update(databaseRef, dataToUpdate);
    };
    changeFieldFromFirebase(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'DELETED');
    updateDummy(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 0);
    setIamUploading(false);
    setActiveUploads((prevUploads) => prevUploads?.filter((id) => id !== draft_id?.draft_id));
    setDraftOfUpload((prevUploads) => prevUploads?.filter((id) => id !== draft_id?.draft_id));
    setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => id !== draft_id?.draft_id));
    updateUploadPercentagesModal(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'Cancelled');
    closeToast(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'Upload has been canceled by user', 'error');
  };
  const handleToCloseUpload = (draft_id, updateUploadPercentagesModal) => {
    toast.update(draft_id, {
      closeButton: <CustomCloseDiv draft_id={draft_id} updateUploadPercentagesModal={updateUploadPercentagesModal} />,
    });
  };
  const CustomCloseButton = ({ draft_id }) => (
    <button className={styles.closeMeBro} onClick={() => handleToCloseUpload(draft_id)}>
      <CloseIcon />
    </button>
  );
  const backToOld = ({ draft_id, updateUploadPercentagesModal }) => {
    toast.update(draft_id, {
      closeButton: <CustomCloseButton draft_id={draft_id} updateUploadPercentagesModal={updateUploadPercentagesModal} />,
    });
  };
  const CustomCloseDiv = (draft_id, updateUploadPercentagesModal) => (
    <div className={styles.customDiv}>
      Are you sure you want to cancel ?
      <div className={styles.fleo}>
        <button className={styles.cancelPlz} onClick={() => backToOld(draft_id, updateUploadPercentagesModal)}>
          Exit
        </button>
        <button className={styles.noCancel} onClick={() => handleEncouter(draft_id)}>
          Continue to cancel
        </button>
      </div>
    </div>
  );
  const notify = (filename, draft_id, uploadPercentages, updateUploadPercentagesModal) => {
    const message = `Uploading ${filename}`;
    if (uploadPercentages[draft_id] === undefined) {
      tempPercentages = { ...uploadPercentages, [draft_id]: 'Initializing' };
      updateUploadPercentagesModal(draft_id, 'Starting Upload');
    }
    toast(message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: false,
      toastId: draft_id,
      closeButton: <CustomCloseButton draft_id={draft_id} updateUploadPercentagesModal={updateUploadPercentagesModal} />,
    });
  };
  const CustomCloseloader = () => (
    <button className={styles.closeMeBro}>
      <Spinner />
    </button>
  );
  async function initMultipartUpload(bucket, key) {
    const params = {
      Bucket: bucket,
      Key: key,
    };
    try {
      const response = await s3.createMultipartUpload(params).promise();
      return response;
    } catch (error) {
      console.error('Error initiating multipart upload:', error);
      throw error;
    }
  }

  async function uploadPart(bucket, key, partNumber, partBody, uploadId, setVideoUploadedParts, filename, draft_id, uploadPercentages, updateUploadPercentagesModal, partSize, startTime, fileSize) {
    const params = {
      Bucket: bucket,
      Key: key,
      PartNumber: partNumber,
      UploadId: uploadId,
      Body: partBody,
    };
    return s3.uploadPart(params)
      .promise()
      .then((data) => {
        const currentTime = new Date().getTime();
        const elapsedSize = (partNumber * partSize) / 1024 / 1024;
        const elapsedTime = (currentTime - startTime) / 1000;
        const remainingSize = (fileSize / 1024 / 1024) - elapsedSize;
        updateUploadDetails(draft_id, { elapsed_size: elapsedSize, elapsed_time: elapsedTime, remaining_size: remainingSize > 0 ? remainingSize : 0 });
        iteratorNum[draft_id] += 1;
        updateItem(iteratorNum[draft_id], draft_id, filename, uploadPercentages, updateUploadPercentagesModal);
        setVideoUploadedParts((prevState = []) => [...prevState, partNumber]);
        return data;
      })
      .catch((err) => {
        console.log(`Error uploading part ${partNumber}:`, err);
        throw err;
      });
  }

  async function uploadPartSequentially(file, bucket, key, uploadId, partNumber, start, partSize, parts, draft_id, startTime) {
    const databaseRef = ref(firebaseDatabase, 'status_from_sns');
    const data = {};
    const dataCallback = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        data[draft_id] = dataObj[draft_id];
      }
    };
    onValue(databaseRef, dataCallback);
    const unsubscribe = () => {
      off(databaseRef, 'value', dataCallback);
    };
    const end = Math.min(start + partSize, file.size);
    if (start < file.size && data[draft_id]?.status !== 'DELETED') {
      await uploadPart(getBucketName(userId), key, partNumber, file.slice(start, end), uploadId, setVideoUploadedParts, file.name, draft_id, uploadPercentages, updateUploadPercentagesModal, partSize, startTime, file.size)
        .then((item) => {
          parts.push({ PartNumber: partNumber, ETag: item.ETag });
        })
        .catch((error) => {
          console.error('Upload part error:', error);
          unsubscribe();
        });
      unsubscribe();
      await uploadPartSequentially(file, bucket, key, uploadId, partNumber + 1, end, partSize, parts, draft_id, startTime);
    }
  }

  async function completeMultipartUpload(bucket, key, parts, uploadId, file, index) {
    const params = {
      Bucket: bucket,
      Key: key,
      MultipartUpload: {
        Parts: parts,
      },
      UploadId: uploadId,
    };
    try {
      const response = await s3.completeMultipartUpload(params).promise();
      let videoDuration = 0;
      let videoHeightI = 0;
      let videoWidthI = 0;
      try {
        const videoElement = document.createElement('video');
        videoElement.src = URL.createObjectURL(file);
        await videoElement?.load();
        videoElement.muted = true;
        // Wait for the metadata to load to access duration, height, and width
        await new Promise((resolve, reject) => {
          videoElement.addEventListener('loadedmetadata', () => {
            videoDuration = videoElement.duration;
            videoHeightI = videoElement.videoHeight;
            videoWidthI = videoElement.videoWidth;
            resolve();
          });
          videoElement.addEventListener('error', reject);
        });
        try {
          await videoElement.play();
        } catch (playError) {
          console.warn('Video play was prevented:', playError);
        }
        videoElement?.pause();
      } catch (e) {
        console.error('Error in getting width and height:', e);
      }
      const formData = new FormData();
      const s3Url = generateS3Url();
      formData.append('token', getToken());
      formData.append('draft_id', file?.draftId);

      // Handle thumbnail - convert noPhotoAvailable to blob if needed
      if (videoThumbnails && videoThumbnails[file?.draftId] && videoThumbnails[file?.draftId][0]) {
        formData.append('thumbnail', videoThumbnails[file?.draftId][0]);
      } else {
        // Convert the default image to blob
        try {
          const response = await fetch(ForNoImage);
          const blob = await response.blob();
          formData.append('thumbnail', blob, 'ForNoImage.png');
        } catch (error) {
          console.error('Error converting default thumbnail to blob:', error);
          // Fallback to original approach if fetch fails
          formData.append('thumbnail', ForNoImage);
        }
      }
      if (videoThumbnails && videoThumbnails[file?.draftId] && Array.isArray(videoThumbnails[file?.draftId])) {
        videoThumbnails[file?.draftId].forEach((thumbnail) => {
          formData.append('thumbnails[]', thumbnail);
        });
      }
      formData.append('title', test && test[file?.draftId] ? test[file?.draftId] : '');
      formData.append('video_duration', videoDuration);
      formData.append('videoOreintation', videoHeightI < videoWidthI ? 1 : 2);
      formData.append('videoHeight', videoHeightI);
      formData.append('videoWidth', videoWidthI);
      selectedItemsInBulk[index].category ? formData.append('category_id', selectedItemsInBulk[index].category) : null;
      formData.append('playlist_ids', selectedItemsInBulk[index]?.playlist?.map((item) => item?.value));
      formData.append('visibility', selectedItemsInBulk[index].visibility);
      formData.append('group_ids', selectedItemsInBulk[index]?.group_ids);
      formData.append('s3_url', `${s3Url}${getBucketNamePath(userId)}/${key}`);
      formData.append('s3_image_bucket_url', s3Url);
      formData.append('s3_status', 'Completed');
      formData.append('bucket_folder_path', `${getBucketNamePath(userId)}/${key}`);
      formData.append('video_size', formatFileSizeAccMb(file.size));
      closeToast(file?.draftId, 'Uploading completed', 'success');
      sendVideoDataToServer(formData, file?.draftId);
      if (subscriptionDetails?.current_plan === 'Free') {
        autoSignIn();
      }
      if (uploadQueue?.length <= 1) {
        if (photoList && photoList.length > 0) {
          setActiveTab(1); // Switch to photo tab
        } else {
          // setOpen(false); // Close modal only if no photos
        }
      }
      return response;
    } catch (error) {
      console.error('Error completing multipart upload:', error);
      if (subscriptionDetails?.current_plan === 'Free') {
        autoSignIn();
      }
      throw error; // Rethrow the error to be handled by the caller
    }
  }
  // console.log('videoThumbnails', videoThumbnails, videoThumbnails64);
  async function uploadLargeFile(bucket, key, file, draft_id, index, fileName) {
    setUploadContainer((prevUploadContainer) => [...prevUploadContainer, draft_id]);
    setUploadContainer2((prevUploadContainer) => [...prevUploadContainer, draft_id]);
    try {
      notify(file.name, draft_id, uploadPercentages, updateUploadPercentagesModal);
      const { UploadId } = await initMultipartUpload(bucket, fileName);
      const minimumPartSize = 5 * 1024 * 1024; // 5MB
      let partSize = file.size / 100;
      if (partSize < minimumPartSize) {
        partSize = minimumPartSize;
      }
      const fileSize = file.size;
      const partCount = Math.ceil(fileSize / partSize);
      const startTime = new Date().getTime();
      const parts = [];
      iteratorNum[draft_id] = 0;
      totalNum[draft_id] = partCount;
      await uploadPartSequentially(file, bucket, fileName, UploadId, 1, 0, partSize, parts, draft_id, startTime);
      const databaseRef = ref(firebaseDatabase, 'status_from_sns');
      const data = {};
      const dataCallback = (snapshot) => {
        if (snapshot.exists()) {
          const dataObj = snapshot.val();
          data[draft_id] = dataObj[draft_id];
        }
      };
      onValue(databaseRef, dataCallback);
      const unsubscribe = () => {
        off(databaseRef, 'value', dataCallback);
      };
      if (data[draft_id]?.status !== 'DELETED') {
        const uploadedData = await completeMultipartUpload(bucket, fileName, parts, UploadId, file, index);
        const newPercentages = { ...uploadPercentages, [draft_id]: 'Please wait' };
        tempPercentages = newPercentages;
        updateUploadPercentagesModal(draft_id, 'Please wait');
        iteratorNum[file.name] = 0;
        totalNum[draft_id] = 0;
        setIamUploading(true);
      } else {
        updateUploadPercentagesModal(draft_id, 'Cancelled');
        closeToast(draft_id, 'Upload has been canceled by user', 'error');
        unsubscribe();
      }
      unsubscribe();
    } catch (error) {
      updateUploadPercentagesModal(draft_id, 'Cancelled');
      closeToast(draft_id, 'Upload has been canceled by user', 'error');
      const newPercentages = { ...uploadPercentages, [draft_id]: 'Cancelled' };
      tempPercentages = newPercentages;
      updateUploadPercentagesModal(draft_id, 'Cancelled');
      updateUploadDetails(draft_id, { elapsed_size: 0, elapsed_time: 0, remaining_size: 0 });
      const allPropertiesAreNumericOrString = Object.values(uploadPercentages).some((value) => typeof value === 'number' || value === 'Starting Upload' || value === 'Initializing');
      if (allPropertiesAreNumericOrString) {
        setIamUploading(false);
      } else setIamUploading(true);
    }
  }

  async function processUploadQueue() {
    if (activeUploads.length < 5 && uploadQueue.length > 0) {
      // Get the next file from the queue
      const nextUpload = uploadQueue[0];

      // Start the upload and remove it from the queue
      setActiveUploads((prevUploads) => [...prevUploads, nextUpload.draftId]);
      setUploadQueue((prevQueue) => prevQueue.slice(1));

      await uploadLargeFile(getBucketName(userId), nextUpload.file.name, nextUpload.file, nextUpload.draftId, nextUpload.index, nextUpload.fileName);
      // Remove from active uploads once completed
      setActiveUploads((prevUploads) => prevUploads.filter((id) => id !== nextUpload.draftId));
    }
  }
  useEffect(() => {
    if (uploadQueue.length > 0 && activeUploads.length < 5) {
      processUploadQueue();
    }
  }, [uploadQueue, activeUploads]);

  // Download control handlers
  const handleCancelAllDownloads = useCallback(() => {
    // Set cancel flag for bulk download loop to check
    bulkDownloadCancelRef.current = true;

    // Abort all active download controllers
    downloadAbortControllersRef.current.forEach((controller) => {
      try {
        controller.abort();
      } catch (error) {
        // Ignore errors
      }
    });
    downloadAbortControllersRef.current.clear();
    pausedDownloadsRef.current.clear();
    resumeTriggersRef.current.clear();
    setDownloadingFiles([]);
    setDownloadBox(false);
    setDownloadBatchProgress({ current: 0, total: 0 });

    // Re-enable download button in YourVideos
    if (setBulkDownloadingRef.current) {
      setBulkDownloadingRef.current(false);
    }
  }, [setDownloadingFiles, setDownloadBox, setDownloadBatchProgress]);

  const handleCancelDownload = useCallback((downloadId) => {
    const controller = downloadAbortControllersRef.current.get(downloadId);
    if (controller) {
      try {
        controller.abort();
      } catch (error) {
        // Ignore errors
      }
      downloadAbortControllersRef.current.delete(downloadId);
    }
    pausedDownloadsRef.current.delete(downloadId);
    setDownloadingFiles((prev) => prev.filter((f) => f.id !== downloadId));
  }, [setDownloadingFiles]);

  const handlePauseDownload = useCallback((downloadId) => {
    // Add to ref first (synchronous) to ensure immediate effect
    pausedDownloadsRef.current.add(downloadId);

    // Update UI state
    setDownloadingFiles((prev) => prev.map((f) => (f.id === downloadId
      ? { ...f, status: 'paused' }
      : f)));
  }, [setDownloadingFiles]);

  const handleResumeDownload = useCallback((downloadId) => {
    // Remove from paused ref first (synchronous)
    pausedDownloadsRef.current.delete(downloadId);

    // Update UI state
    setDownloadingFiles((prev) => prev.map((f) => (f.id === downloadId
      ? { ...f, status: 'downloading' }
      : f)));

    // If there's a resume trigger function registered, call it to restart the download
    const resumeTrigger = resumeTriggersRef.current.get(downloadId);
    if (resumeTrigger) {
      resumeTrigger();
      resumeTriggersRef.current.delete(downloadId);
    }
  }, [setDownloadingFiles]);

  // console.log('selectedFiles', showMultipleModal, selectedFilesMulti);
  return (
    <AuthContext.Provider
      value={{
        forceAutoSignin,
        getToken,
        preferredEmail,
        removeToken,
        userIsSignedIn,
        setPreferredEmail,
        preferredUserDetails,
        setPreferredUserDetails,
        setToken,
        setUserSignInStatus,
        setPlansPage,
        plansPage,
        isInActiveUser,
        gettingSubscription,
        getEmailVerified,
        setEmailVerified,
        removeEmailVerified,
      }}
    >
      <AppContext.Provider
        value={{
          setOpenPaymentSuccess,
          formatFileSizeAccMb,
          warningTitle,
          warningMessage,
          totalOnGoingUploadSize,
          freePlanLimitMb,
          hasReachedStorageLimit,
          selectedFilesMulti,
          setSelectedFilesMulti,
          showMultipleModal,
          setShowMultipleModal,
          showAddPlaylistModal,
          setShowAddPlaylistModal,
          openNewUploadModal,
          setOpenNewUploadModal,
          openPhotoUploadModal,
          setOpenPhotoUploadModal,
          photoAlbumModalOpen,
          setPhotoAlbumModalOpen,
          pendingCloudPhotos,
          setPendingCloudPhotos,
          pendingCloudPhotoService,
          setPendingCloudPhotoService,
          base64ToBinary,
          activeTab,
          setActiveTab,
          videoThumbnails,
          setVideoThumbnails,
          videoThumbnails64,
          setVideoThumbnails64,
          findAllVideoCategory,
          setFindAllVideoCategory,
          selectedItemsInBulk,
          setSelectedItemsInBulk,
          processUploadQueue,
          IsfreePlan,
          MAX_SIZE_GB,
          chooseAlbumStep,
          setChooseAlbumStep,
          photoList,
          setPhotoList,
          options,
          setOptions,
          setUploadModalVisibility,
          setImageFiles,
          imageFiles,
          loginWithSocial,
          setLoginWithSocial,
          popUpModalVisible,
          setPopUpModalVisible,
          uploadType,
          setUpdateType,
          isEmailAllowed,
          allowedEmails,
          setAllowedEmails,
          clearChecked,
          stripeUiSelector,
          setStripeUiSelector,
          checked,
          setChecked,
          setOpen,
          videoFiles,
          setVideoFiles,
          pendingVideoFile,
          setPendingVideoFile,
          pendingPhotoFiles,
          setPendingPhotoFiles,
          screatId,
          setScreatId,
          defaultCategoryName,
          setOpenPaymentLoader,
          setCardExpiryDialog,
          isIOS,
          categoryDetails,
          tabTitle,
          setTabTitle,
          setCategoryDetails,
          albumDetails,
          setAlbumDetails,
          storageSelectedType,
          navigateToInviteFirstTime,
          setStorageSelectedType,
          storageSearchTerm,
          setStorageSearchTerm,
          storageSelectedDate,
          setStorageSelectedDate,
          storageTabTitle,
          setStorageTabTitle,
          storageSelectedItems,
          setStorageSelectedItems,
          categoryRefreshTrigger,
          setCategoryRefreshTrigger,
          playlistRefreshTrigger,
          setPlaylistRefreshTrigger,
          newlyCreatedPlaylistId,
          setNewlyCreatedPlaylistId,
          newlyCreatedPlaylistTitle,
          setNewlyCreatedPlaylistTitle,
          showAddSubCategoryModal,
          setShowAddSubCategoryModal,
          subCategoryRefreshTrigger,
          setSubCategoryRefreshTrigger,
          newlyCreatedSubCategoryId,
          setNewlyCreatedSubCategoryId,
          setFromLogin,
          isGettingValidSub,
          planPurchasing,
          setPlanPurchasing,
          setOpenX,
          cloudToken,
          setCloudToken,
          openX,
          expressloading,
          orderArrange,
          setOrderArrange,
          fetchLayoutOrder,
          affliatePlanId,
          setAffliatePlanId,
          setExpressLoading,
          isFromAffl,
          setisFromAffl,
          selectedPlan,
          selectPlan,
          backendUrl,
          expressCheckout,
          cardUpdateBoolean,
          setcardUpdateBoolean,
          trailModalVisible,
          setTrailPopUpModalVisible,
          uploadContainer2,
          setUploadContainer2,
          cardPayId,
          setcardPayId,
          cardUpdate,
          setcardUpdate,
          trialVal,
          setTrial,
          didIOpenModal,
          allvideoData,
          setAllvideoData,
          isCompleted,
          setisCompleted,
          firstTimeOnlychecked,
          setFirstTimeOnlyChecked,
          cardAdded,
          setcardAdded,
          navigateOnceClicked,
          buttonText,
          setNavigateOnceClicked,
          MAX_VIDEOS,
          MAX_PHOTOS,
          trailVideos,
          activeModalId,
          setActiveModalId,
          isUploadingBulky,
          setIsUploadingBulky,
          uploadQueue,
          setUploadQueue,
          activeUploads,
          setActiveUploads,
          draftOfUpload,
          setDraftOfUpload,
          totalDraft,
          uploadProcessing,
          setUploadProcessing,
          setdidIOpenModal,
          disableDrag,
          setdisableDrag,
          isTrail,
          setIsTrail,
          removeProjectorTextChange,
          setRemoveProjectorTextChange,
          dataOfCategory,
          profileDetails,
          addMorePhoto,
          videoGroup,
          setVideoGroup,
          selectedFiles,
          setSelectedFiles,
          setaddMorePhoto,
          setfetchDraftID,
          setProfileDetails,
          setFormData,
          isAddDraftDone,
          pubLoader,
          cardNumber,
          profileLoader,
          setProfileLoader,
          setCardNumber,
          cvvNumber,
          setCvvNumber,
          expirationDate,
          setExpirationDate,
          setPubLoader,
          setisAddDraftDone,
          draftCategoryState,
          setDraftCategoryState,
          isS3UploadComplete,
          setS3UploadComplete,
          setdataOfCategory,
          selectedItems,
          setSelectedItems,
          singleEdit,
          encounterLoading,
          loader,
          setLoader,
          setEncounterLoading,
          needToShowETA,
          setNeedToShowETA,
          setSingleEdit,
          setUploadContainer,
          uploadContainer,
          uploaderLoader,
          setUploaderLoader,
          holdWhileDelete,
          setholdWhileDelete,
          referralCode,
          visible,
          setVisible,
          textOfUpload,
          setLoadingState,
          contextLoading,
          setContextLoading,
          profileName,
          setProfileName,
          amICalled,
          setamICalled,
          settextOfUpload,
          setHelpNeed,
          s3Data,
          fetchData,
          invalidErr,
          setinvalidErr,
          isInvalid,
          setIsInvalid,
          apiResponse,
          isLoading,
          topOrBottom,
          setTopOrBottom,
          autoSignIn,
          uploadPercentagesInNumber,
          setUploadPercentagesInNumber,
          getAccessChecker,
          setGetAccessChecker,
          iamUploading,
          setIamUploading,
          isTokenChange,
          setIsTokenChange,
          setS3Data,
          affiliateCode,
          setAffiliatedCode,
          handleManger,
          lineReq,
          setLineReq,
          messaged,
          setmessaged,
          mangerFunctionData,
          setmangerFunctionData,
          handleClick,
          switchingFunction,
          bigUserData,
          setbigUserData,
          setMangerToken,
          mangerToken,
          userAccessedData,
          managerPrivatePlanAccess,
          managerPaymentMethods,
          setHoldTheWeb,
          toastForGroup,
          setToastForGroup,
          getUserConnections,
          gettingUserConnections,
          setAppSnackbar,
          setUserConnections,
          setUserDetails,
          userConnections,
          userDetails,
          subscriptionDetails,
          getSubscription,
          setPlansPage,
          plansPage,
          currentSelectedPlan,
          setCurrentSelectedPlan,
          langText,
          setReferralStatus,
          referralStatus,
          isViewerListUpdated,
          setViewerListUpdate,
          showProgressBox,
          setProgressBox,
          showDownloadBox,
          setDownloadBox,
          downloadingFiles,
          setDownloadingFiles,
          downloadBatchProgress,
          setDownloadBatchProgress,
          downloadAbortControllersRef,
          pausedDownloadsRef,
          resumeTriggersRef,
          bulkDownloadCancelRef,
          setBulkDownloadingRef,
          onDownloadPanelVisibleRef,
          handleCancelAllDownloads,
          handleCancelDownload,
          handlePauseDownload,
          handleResumeDownload,
          uploadingVideo,
          setUploadingVideo,
          uploadingVideoDetails,
          setUploadingVideoDetails,
          uploadProgress,
          setUploadProgress,
          visibility,
          setVisibility,
          flowEventHandler,
          startingFlowEvent,
          isSingleUpload,
          eta,
          closeModal,
          apiCALL,
          setapiCALL,
          setSingleUpload,
          pageLoad,
          removeToken,
          setPageLoad,
          setVideoCount,
          videoCount,
          errorMsg,
          setModalVisibility,
          setUniqueId,
          setAllPlans,
          allPlans,
          selectedUploadFiles,
          setSelectedUploadFiles,
          draftContent,
          setDraftContent,
          setVideoUploadedParts,
          daysOfMonths,
          refreshContent,
          setRefreshContent,
          uploadPercentages,
          updateUploadPercentages,
          firebaseDatabase,
          setUploadingInProgress,
          uploadingInProgress,
          photoAlbumLoader,
          setphotoAlbumLoader,
          theGrtLoader,
          settheGrtLoader,
          categoryLoader,
          setcategoryLoader,
        }}
      >
        {openPaymentLoader && (
          <RotatingLoader
            colour="white"
            text="Processing Payment..."
            background="radial-gradient(circle at center,#1f2330,#07080c)"
          />
        )}
        <div
          className={styles.app}
          onDrop={disableDrag === true ? handleDrop : handleSingleDrop}
          onDragOver={(e) => dragOver(e)}
          onDragLeave={(e) => dragLeave(e)}
        >
          {showPaymentDialog && (
            <CardExp
              handleClose={handleCloseDialog}
              title="Unlock your Projector"
              buttonText="Update Payment method now"
              contentText="Please update your payment method or your account will be suspended and your content will be at your risk for deletion."
            />
          )}
          {cardExpiryDialog && (
            <CardExp
              title="Unlock your Projector"
              contentText="Please update your payment method as your subscriptions maybe interrupted."
              buttonText="Update Payment method now"
              handleClose={handleCloseCardEXPDialog}
            />
          )}
          {openPaymentSuccess && (
            <SuccessPopUp
              expressData={expressData}
              paymentNavigation={paymentNavigation}
              paymentStatus={paymentStatus}
              setOpenPaymentLoader={setOpenPaymentLoader}
              onHide={() => setOpenPaymentSuccess(false)}
            />
          )}
          {autoSigningIn || loadingForAccess ? (
            <div className={styles.autoSignInSpinnerContainer}>
              <CircularProgress />
            </div>
          ) : (
            <Router>
              <RouteSwitch
                {...{
                  setUserSignInStatus,
                  isNewUser: userDetails?.isNewUser,
                  userIsSignedIn,
                  isInActiveUser,
                  isEmailAllowed
                }}
              />
            </Router>
          )}
        </div>

        <Snackbar
          autoHideDuration={appSnackbar?.duration}
          isVisible={appSnackbar?.isVisible}
          message={appSnackbar?.message || ''}
          onClose={() => {
            setAppSnackbar(defaultAppSnackbar);
          }}
          type={appSnackbar?.type}
        />
        {/* Old Upload ETA Panel - Only show when using legacy upload system */}
        {!UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM && needToShowETA === true && uploadContainer?.length > 0 && (
          <div className={styles.fullSpeed}>
            {!Number.isNaN(eta) && (
              <div className={styles.Sppped}>
                {eta > 1
                  ? `${eta} Minutes remaining`
                  : eta <= 1
                    ? 'Less than a minute'
                    : 'Calculating'}
              </div>
            )}
            <button
              className={styles.hideOrShow}
              onClick={() => setToastVisiblity(!toastVisiblity)}
            >
              {toastVisiblity !== true ? (
                <img src={DownArrow} alt="" />
              ) : (
                <img src={UpArrow} alt="" />
              )}
            </button>
          </div>
        )}
        {/* { droper && <DropMe dragLeave={dragLeave} dragOver={dragOver} handleDrop={handleDrop} />} */}
        {open && (
          <ListingModal
            buttonText={buttonText}
            setButtonText={setButtonText}
            setOpen={() => setOpen(false)}
            setEditLoader={setEditLoader}
            videoFiles={videoFiles}
            setVideoFiles={setVideoFiles}
          />
        )}
        {/* {uploadModalIsVisible && (
          <UploadModal
            isVisible={uploadModalIsVisible}
            onHide={hideUploadModal}
            imageFiles={imageFiles}
          />
        )} */}
        <ToastContainer
          closeOnClick={false}
          className={
            toastVisiblity !== true
              ? styles.toastContainerShow
              : styles.toastContainerNone
          }
        />
        {/* New Upload Panel - Shows when using new upload system (hidden on gift flow - has its own progress UI) */}
        {UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM && UPLOAD_CONFIG.SHOW_UPLOAD_PANEL && !window.location.pathname.startsWith('/gift') && (
          <UploadPanel />
        )}

        {/* Add Playlist Modal - Available throughout the app */}
        {showAddPlaylistModal && (
          <AddPlaylistModal
            open={showAddPlaylistModal}
            onClose={() => setShowAddPlaylistModal(false)}
            onPlaylistCreated={(newPlaylist) => {
              setShowAddPlaylistModal(false);
              setNewlyCreatedPlaylistId(newPlaylist?.id || null);
              setNewlyCreatedPlaylistTitle(newPlaylist?.title || null);
              setPlaylistRefreshTrigger((prev) => prev + 1);
            }}
          />
        )}

        {/* Add SubCategory Modal - Available throughout the app */}
        {showAddSubCategoryModal && (
          <AddSubCategoryModal
            open={showAddSubCategoryModal}
            onClose={() => setShowAddSubCategoryModal(false)}
            onSubCategoryCreated={(newSubCategory) => {
              setShowAddSubCategoryModal(false);
              setNewlyCreatedSubCategoryId(newSubCategory?.id || null);
              setSubCategoryRefreshTrigger((prev) => prev + 1);
            }}
          />
        )}
      </AppContext.Provider>
    </AuthContext.Provider>
  );
};
